/* naqa-custom.js (Lea) — header integre au hero video : transparent tant que la video est a l'ecran */
(function () {
  var ticking = false;
  function update() {
    ticking = false;
    var hero = document.querySelector('[class*="hero-template"][class*="video_hero"]');
    var secH = document.querySelector('.section-header');
    if (!secH) return;
    if (!hero) { secH.classList.remove('naqa-over-hero'); return; }
    var r = hero.getBoundingClientRect();
    var hh = secH.offsetHeight || 90;
    if (r.bottom > hh) {
      secH.classList.add('naqa-over-hero');
    } else {
      secH.classList.remove('naqa-over-hero');
    }
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }
  function closeMegaMenus(except) {
    document.querySelectorAll('details[id^="ProductsMegaMenu"][open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }
  function bindMenuClose() {
    document.querySelectorAll('.header__inline-menu > ul > li').forEach(function (li) {
      if (li.dataset.naqaBound) return;
      li.dataset.naqaBound = '1';
      li.addEventListener('mouseenter', function () {
        var det = li.querySelector('details[id^="ProductsMegaMenu"]');
        closeMegaMenus(det);
      });
    });
    var hd = document.querySelector('header.header');
    if (hd && !hd.dataset.naqaBound) {
      hd.dataset.naqaBound = '1';
      hd.addEventListener('mouseleave', function () { closeMegaMenus(null); });
    }
  }
  function moveRatingCounts() {
    document.querySelectorAll('.rating').forEach(function (r) {
      if (r.querySelector('.rating-count')) return;
      var p = r.parentElement;
      var count = p ? p.querySelector(':scope > .rating-count') : null;
      if (count) r.appendChild(count);
    });
  }
  function splitTitles() {
    var links = document.querySelectorAll('#MainContent .card--card .card__heading a, .products-mega-menu__cards .card__heading a');
    links.forEach(function (a) {
      if (a.dataset.naqaSplit) return;
      var t = (a.textContent || '').trim();
      var m = t.match(/^(.+?)\s*:\s*(.+)$/);
      if (!m) return;
      a.dataset.naqaSplit = '1';
      a.textContent = '';
      var s1 = document.createElement('span');
      s1.className = 'naqa-title';
      s1.textContent = m[1];
      var s2 = document.createElement('span');
      s2.className = 'naqa-sub';
      s2.textContent = m[2];
      a.appendChild(s1);
      a.appendChild(s2);
    });
  }
  function centerMenuCards() {
    document.querySelectorAll('.products-mega-menu__content .products-mega-menu__cards').forEach(function (ul) {
      ul.style.justifyContent = (ul.scrollWidth <= ul.clientWidth + 4) ? 'center' : 'flex-start';
    });
  }
  function loadRecommendations() {
    return; /* remplace par « complete ta routine » naqa */
    document.querySelectorAll('product-recommendations[data-url]').forEach(function (el) {
      if (el.dataset.naqaLoaded) return;
      if (el.querySelector('.card--card, .grid__item')) { el.dataset.naqaLoaded = '1'; return; }
      el.dataset.naqaLoaded = '1';
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
          if (typeof splitTitles === 'function') setTimeout(splitTitles, 100);
          if (typeof moveRatingCounts === 'function') setTimeout(moveRatingCounts, 100);
        })
        .catch(function () {});
    });
  }
  function init() {
    update();
    bindMenuClose();
    setTimeout(loadRecommendations, 400);
    document.addEventListener('shopify:section:load', function(){ setTimeout(loadRecommendations, 300); });
    moveRatingCounts();
    splitTitles();
    centerMenuCards();
    window.addEventListener('resize', centerMenuCards, { passive: true });
    document.addEventListener('mouseover', function (e) {
      if (e.target && e.target.closest && e.target.closest('.header__inline-menu')) setTimeout(centerMenuCards, 120);
    }, { passive: true });
    document.addEventListener('shopify:section:load', function(){ setTimeout(splitTitles, 150); });
    document.addEventListener('shopify:section:load', function(){ setTimeout(moveRatingCounts, 150); });
    document.addEventListener('shopify:section:load', function(){ setTimeout(bindMenuClose, 100); });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('shopify:section:load', function(){ setTimeout(update, 50); });
    document.addEventListener('shopify:section:unload', function(){ setTimeout(update, 50); });
    setInterval(update, 1200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

/* ============================================================
   PANIER PREMIUM naqa (Lea) : livraison offerte, cadeau, upsell
   ============================================================ */
(function () {
  /* Paliers cadeaux : 40 EUR sticker card, 200 EUR tote bag ou trousse au choix */
  var PALIER_STICKER = 4000;
  var PALIER_CADEAU = 20000;
  /* IDs de variante des cadeaux (a renseigner quand les produits existent) */
  var CDN = 'https://naqa.fr/cdn/shop/files/';
  var OFFERTS = [
    { nom: 'la sticker card', id: 54410566238554, img: CDN + 'stickers.png?width=200' },
    { nom: 'l\u2019\u00E9chantillon 2 gummies', id: 54410568171866, img: CDN + 'gummies.png?width=200' }
  ];
  var CADEAUX = [
    { nom: 'le tote bag', id: 54410568302938, img: CDN + 'totebag.png?width=200' },
    { nom: 'la trousse naqä', id: null, img: CDN + 'trousse.png?width=200' }
  ];
  var fmt = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };

  function buildProgress(cart) {
    var total = cart.total_price;
    var pct = Math.min(100, Math.round((total / PALIER_CADEAU) * 100));
    var posLiv = Math.round((PALIER_LIVRAISON / PALIER_CADEAU) * 100);
    var txt;
    if (total < PALIER_LIVRAISON) {
      txt = 'Plus que <strong>' + fmt(PALIER_LIVRAISON - total) + '</strong> pour la <strong>livraison offerte</strong>';
    } else if (total < PALIER_CADEAU) {
      txt = 'Livraison offerte ✓ &nbsp;·&nbsp; plus que <strong>' + fmt(PALIER_CADEAU - total) + '</strong> pour ton <strong>cadeau</strong>';
    } else {
      txt = 'Livraison offerte ✓ &nbsp;·&nbsp; <strong>cadeau debloque</strong> 🎁';
    }
    return '<div class="naqa-cart-progress">' +
             '<p class="naqa-cart-progress__label">' + txt + '</p>' +
             '<div class="naqa-cart-progress__track">' +
               '<span class="naqa-cart-progress__fill" style="width:' + pct + '%"></span>' +
               '<i class="naqa-cart-progress__step' + (total >= PALIER_LIVRAISON ? ' is-done' : '') + '" style="left:' + posLiv + '%"></i>' +
               '<i class="naqa-cart-progress__step naqa-cart-progress__step--end' + (total >= PALIER_CADEAU ? ' is-done' : '') + '"></i>' +
             '</div>' +
             '<div class="naqa-cart-progress__legend">' +
               '<span class="' + (total >= PALIER_LIVRAISON ? 'is-done' : '') + '">80 € livraison</span>' +
               '<span class="' + (total >= PALIER_CADEAU ? 'is-done' : '') + '">200 € cadeau</span>' +
             '</div>' +
             buildGiftChoice(cart, total) +
           '</div>';
  }

  function pick(label, choisi, list, attr) {
    var actif = list.filter(function (c) { return c.nom === choisi; })[0] || list[0];
    var sel = list.map(function (c) {
      return '<option value="' + c.nom + '" data-img="' + (c.img || '') + '"' + (choisi === c.nom ? ' selected' : '') + '>' + c.nom + '</option>';
    }).join('');
    var visuel = (actif && actif.img)
      ? '<img class="naqa-gift__thumb" src="' + actif.img + '" alt="" />'
      : '<span class="naqa-gift__thumb naqa-gift__thumb--ph">🎁</span>';
    return '<div class="naqa-cart-giftpick">' +
             '<p class="naqa-cart-giftpick__title">' + label + '</p>' +
             '<div class="naqa-gift__card">' +
               visuel +
               '<div class="naqa-gift__body">' +
                 '<span class="naqa-gift__label">choisis ton cadeau</span>' +
                 '<select class="naqa-gift__select" data-attr="' + attr + '">' + sel + '</select>' +
               '</div>' +
               '<div class="naqa-gift__actions">' +
                 '<button type="button" class="naqa-gift__add" data-attr="' + attr + '">ajouter</button>' +
                 '<span class="naqa-gift__saved" hidden>ajouté ✓</span>' +
               '</div>' +
             '</div>' +
           '</div>';
  }

  function buildGiftChoice(cart, total) {
    var a = cart.attributes || {};
    if (total < PALIER_STICKER) {
      return '<div class="naqa-cart-giftpick naqa-cart-giftpick--locked">' +
               '<p class="naqa-cart-giftpick__title">TON <strong>cadeau offert</strong> d\u00E8s 40 \u20AC \u2661</p>' +
             '</div>';
    }
    var html = pick('TON <strong>cadeau offert</strong> \u2014 sticker card ou \u00E9chantillon 2 gummies \u2661', a['Cadeau offert'] || '', OFFERTS, 'Cadeau offert');
    if (total >= PALIER_CADEAU) {
      html += pick('ET ton <strong>2\u1D49 cadeau</strong> \u2014 <strong>tote bag</strong> ou <strong>trousse naq\u00E4</strong>, d\u00E8s 200 \u20AC \u2661', a['Cadeau'] || '', CADEAUX, 'Cadeau');
    }
    return html;
  }

  function buildGift(cart) {
    var note = (cart.attributes && cart.attributes['Message cadeau']) || '';
    var isGift = (cart.attributes && cart.attributes['Commande cadeau']) === 'oui';
    return '<div class="naqa-cart-gift">' +
             '<button type="button" class="naqa-cart-gift__toggle" aria-expanded="' + (isGift ? 'true' : 'false') + '">' +
               'ajouter une note' +
             '</button>' +
             '<div class="naqa-cart-gift__panel"' + (isGift ? '' : ' hidden') + '>' +
               '<p class="naqa-cart-gift__hint">On glisse un mot doux et on masque le prix.</p>' +
               '<textarea class="naqa-cart-gift__note" rows="2" maxlength="200" placeholder="Ton message (200 caracteres max)">' + note + '</textarea>' +
               '<button type="button" class="naqa-cart-gift__save">enregistrer le message</button>' +
               '<span class="naqa-cart-gift__saved" hidden>message enregistre ✓</span>' +
             '</div>' +
           '</div>';
  }

  function bindGift(root) {
    var toggle = root.querySelector('.naqa-cart-gift__toggle');
    var panel = root.querySelector('.naqa-cart-gift__panel');
    var save = root.querySelector('.naqa-cart-gift__save');
    var saved = root.querySelector('.naqa-cart-gift__saved');
    var note = root.querySelector('.naqa-cart-gift__note');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden');
      if (open) { panel.removeAttribute('hidden'); toggle.setAttribute('aria-expanded', 'true'); }
      else { panel.setAttribute('hidden', ''); toggle.setAttribute('aria-expanded', 'false'); }
    });
    if (save) save.addEventListener('click', function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Commande cadeau': 'oui', 'Message cadeau': note.value } })
      }).then(function () { if (saved) { saved.removeAttribute('hidden'); setTimeout(function(){ saved.setAttribute('hidden',''); }, 2500); } });
    });
  }

  function buildUpsell(items) {
    if (!items.length) return '';
    var cards = items.map(function (p) {
      return '<li class="naqa-cart-upsell__item">' +
               '<img src="' + (p.featured_image || p.image) + '&width=120" alt="" />' +
               '<div class="naqa-cart-upsell__info">' +
                 '<span class="naqa-cart-upsell__title">' + p.title.split(':')[0].trim() + '</span>' +
                 '<span class="naqa-cart-upsell__price">' + fmt(p.price) + '</span>' +
               '</div>' +
               '<button type="button" class="naqa-cart-upsell__add" data-id="' + p.variants[0].id + '">+</button>' +
             '</li>';
    }).join('');
    return '<div class="naqa-cart-upsell"><p class="naqa-cart-upsell__heading">Complete ta routine</p><ul class="naqa-cart-upsell__list">' + cards + '</ul></div>';
  }

  function bindUpsell(root) {
    root.querySelectorAll('.naqa-cart-upsell__add').forEach(function (b) {
      b.addEventListener('click', function () {
        b.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(b.dataset.id, 10), quantity: 1 }] })
        }).then(function () { location.reload(); });
      });
    });
  }

  var renderTimer = null;
  window.__naqaGiftRender = render;
  function render() {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(doRender, 150);
  }
  function doRender() {
    var body = document.querySelector('.cart-drawer__body');
    if (!body) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.naqa-cart-extras').forEach(function (n) { n.remove(); });
      if (!cart.item_count) return;

      var wrap = document.createElement('div');
      wrap.className = 'naqa-cart-extras';
      wrap.innerHTML = buildGiftChoice(cart, cart.total_price) + buildGift(cart);
      var footer = document.querySelector('.drawer__footer');
      if (footer) footer.parentNode.insertBefore(wrap, footer);
      else body.parentNode.insertBefore(wrap, body.nextSibling);
      setTimeout(moveUpsell, 60);
      bindGift(wrap);
      wrap.querySelectorAll('.naqa-gift__select').forEach(function (s) {
        s.addEventListener('change', function () {
          var opt = s.options[s.selectedIndex];
          var card = s.closest('.naqa-gift__card');
          var thumb = card ? card.querySelector('.naqa-gift__thumb') : null;
          if (thumb && opt && opt.dataset.img) {
            if (thumb.tagName === 'IMG') { thumb.src = opt.dataset.img; }
            else {
              var img = document.createElement('img');
              img.className = 'naqa-gift__thumb';
              img.src = opt.dataset.img;
              thumb.replaceWith(img);
            }
          }
        });
      });
      wrap.querySelectorAll('.naqa-gift__add').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = b.closest('.naqa-gift__card');
          var sel = card.querySelector('.naqa-gift__select');
          var attr = b.dataset.attr || 'Cadeau';
          var val = sel ? sel.value : '';
          var saved = card.querySelector('.naqa-gift__saved');
          b.disabled = true;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify((function () { var o = {}; o[attr] = val; return { attributes: o }; })())
          }).then(function () {
            b.disabled = false;
            if (saved) { saved.removeAttribute('hidden'); setTimeout(function () { saved.setAttribute('hidden', ''); }, 2500); }
          });
        });
      });

      return; /* upsell desactive : le theme a deja "Completez votre commande" */
      var ids = cart.items.map(function (i) { return i.product_id; });
      fetch('/recommendations/products.json?product_id=' + ids[0] + '&limit=6&intent=complementary')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var reco = (d.products || []).filter(function (p) { return ids.indexOf(p.id) === -1 && p.available; }).slice(0, 2);
          if (!reco.length) return;
          if (document.querySelector('.naqa-cart-upsell')) return;
          var up = document.createElement('div');
          up.className = 'naqa-cart-extras naqa-cart-extras--bottom';
          up.innerHTML = buildUpsell(reco);
          var footer = document.querySelector('.drawer__footer');
          if (footer) footer.parentNode.insertBefore(up, footer);
          bindUpsell(up);
        }).catch(function () {});
    }).catch(function () {});
  }

  /* Bugfix theme : le bouton + de l'upsell est un submit hors formulaire */
  function fixUpsellButtons() {
    document.querySelectorAll('.upsell__checkbox, .upsell-toggle-btn').forEach(function (b) {
      if (b.dataset.naqaFixed) return;
      b.dataset.naqaFixed = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var scope = b.closest('.upsell__container') || b.closest('cart-drawer-upsell') || b.parentElement;
        var form = scope ? scope.querySelector('form[action*="/cart/add"]') : null;
        var idInput = form ? form.querySelector('[name="id"]') : null;
        if (!idInput) return;
        b.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          location.reload();
        }).catch(function () { b.disabled = false; });
      }, true);
    });
  }
  /* upsell : place juste avant le footer (donc sous l'espace cadeau) */
  var upsellMoving = false;
  function moveUpsell() {
    if (upsellMoving) return;
    var ups = document.querySelectorAll('.cart-drawer cart-drawer-upsell');
    var footer = document.querySelector('.cart-drawer .drawer__footer');
    if (!ups.length || !footer) return;
    var zone = document.querySelector('.naqa-upsell-zone');
    var dejaOk = zone && zone.children.length === ups.length && zone.nextElementSibling === footer;
    if (dejaOk) return;
    upsellMoving = true;
    try {
      if (!zone) {
        zone = document.createElement('div');
        zone.className = 'naqa-upsell-zone';
      }
      document.querySelectorAll('.naqa-upsell-title').forEach(function (t) { t.remove(); });
      var titre = document.createElement('p');
      titre.className = 'naqa-upsell-title';
      titre.textContent = 'complète ta commande';
      footer.parentNode.insertBefore(titre, footer);
      footer.parentNode.insertBefore(zone, footer);
      ups.forEach(function (u) { zone.appendChild(u); });
    } catch (e) {}
    setTimeout(function () { upsellMoving = false; }, 300);
  }  function collapseUpsell() {
    var splide = document.querySelector('.cart-drawer .splide');
    if (splide && !splide.dataset.naqaTitled) {
      splide.dataset.naqaTitled = '1';
      var h = document.createElement('p');
      h.className = 'naqa-upsell-title';
      h.textContent = 'complète ta commande';
      splide.parentNode.insertBefore(h, splide);
    }
    document.querySelectorAll('.cart-drawer .splide__slide .upsell__heading, .cart-drawer .splide__slide h2, .cart-drawer .splide__slide h3').forEach(function (x) {
      x.style.display = 'none';
    });
  }
  function naqaCart() {
    render();
    fixUpsellButtons();
    collapseUpsell();
    moveUpsell();
    var upTimer = null;
    var upObs = new MutationObserver(function () {
      if (upsellMoving) return;
      clearTimeout(upTimer);
      upTimer = setTimeout(function () { collapseUpsell(); moveUpsell(); }, 250);
    });
    var cdRoot = document.querySelector('cart-drawer');
    if (cdRoot) upObs.observe(cdRoot, { childList: true, subtree: true });
    var upsTimer = null;
    var upsObs = new MutationObserver(function () {
      clearTimeout(upsTimer);
      upsTimer = setTimeout(fixUpsellButtons, 200);
    });
    var cdNode = document.querySelector('cart-drawer');
    if (cdNode) upsObs.observe(cdNode, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[href*="cart"], .cart-icon-bubble, .quick-add button, .product-form__submit')) {
        setTimeout(render, 900);
      }
    });
    document.addEventListener('cart:refresh', function () { setTimeout(render, 300); });
    var obs = new MutationObserver(function () { setTimeout(render, 250); });
    var cd = document.querySelector('cart-drawer');
    if (cd) obs.observe(cd, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', naqaCart);
  else naqaCart();
})();


/* ============================================================
   MODULE PANIER naqä : paliers cadeaux + « complète ta commande »
   Un seul appel /cart.js par mise à jour, débounce 500 ms.
   ============================================================ */
(function () {
  var SEUIL_LIVRAISON = 8000;
  var SEUIL_OFFERT = 4000;
  var SEUIL_CADEAU = 20000;
  var HANDLES = [
    'parfum-cheveux-huile-seche-florale-aura-blanche',
    'chouchou-soie-anti-casse-anti-frisottis-silk-bloom',
    'brume-corps-apres-douche-ultra-concentree-fleurs-blanches-bloomist'
  ];
  var produits = null;
  var enVol = false;
  var minuteur = null;
  var dernier = '';

  function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + ' \u20AC'; }

  /* ---------- paliers ---------- */
  function paliers(total) {
    /* barre livraison : tout en haut du panier */
    var drawerBody = document.querySelector('.cart-drawer .cart-drawer__body');
    if (drawerBody) {
      var pctL = Math.min(100, Math.max(4, Math.round((total / SEUIL_LIVRAISON) * 100)));
      var txtL = total < SEUIL_LIVRAISON
        ? 'Plus que <strong>' + euros(SEUIL_LIVRAISON - total) + '</strong> pour la livraison offerte'
        : 'Livraison offerte \u2713';
      var htmlL = '<p class="naqa-ship__text">' + txtL + '</p>' +
        '<div class="naqa-ship__bar"><span style="width:' + pctL + '%"></span></div>';
      var barre = document.querySelector('.naqa-ship');
      if (!barre) {
        barre = document.createElement('div');
        barre.className = 'naqa-ship';
        drawerBody.parentNode.insertBefore(barre, drawerBody);
      }
      if (barre.innerHTML !== htmlL) barre.innerHTML = htmlL;
    }

    /* phrase cadeau : dans l'encart bordeaux */
    var host = document.querySelector('.naqa-cart-giftpick');
    if (!host) return;
    var txt;
    if (total < SEUIL_OFFERT) {
      txt = 'Plus que <strong>' + euros(SEUIL_OFFERT - total) + '</strong> pour choisir ton cadeau : stickers ou gummies';
    } else if (total < SEUIL_CADEAU) {
      txt = 'Plus que <strong>' + euros(SEUIL_CADEAU - total) + '</strong> pour choisir ton tote bag ou ta trousse';
    } else {
      txt = 'Ton cadeau est d\u00E9bloqu\u00E9 \u2728 fais ton choix';
    }
    var html = '<p class="naqa-goal__text">' + txt + '</p>';
    var el = host.querySelector('.naqa-goal');
    if (!el) {
      el = document.createElement('div');
      el.className = 'naqa-goal';
      var titre = host.querySelector('.naqa-cart-giftpick__title');
      if (titre && titre.nextSibling) host.insertBefore(el, titre.nextSibling);
      else host.appendChild(el);
    }
    if (el.innerHTML !== html) el.innerHTML = html;
  }

  /* ---------- etat des cadeaux choisis (un encart par palier) ---------- */
  function etatCadeau(attrs) {
    document.querySelectorAll('.naqa-cart-giftpick').forEach(function (host) {
      var sel = host.querySelector('.naqa-gift__select');
      var btn = host.querySelector('.naqa-gift__add');
      if (!sel || !btn) return;
      var cle = btn.dataset.attr || 'Cadeau';
      var choisi = attrs[cle] || '';
      if (choisi && choisi === sel.value) {
        host.classList.add('naqa-gift--ok');
        if (btn.textContent !== 'ajout\u00E9 \u2713') btn.textContent = 'ajout\u00E9 \u2713';
      } else {
        host.classList.remove('naqa-gift--ok');
        if (btn.textContent !== 'ajouter') btn.textContent = 'ajouter';
      }
    });
  }

  /* ---------- titre du panier : nombre d'articles ---------- */
  function titrePanier(cart) {
    var h = document.querySelector('.cart-drawer .drawer__heading');
    if (!h) return;
    var n = cart.item_count || 0;
    var txt = n + (n > 1 ? ' articles' : ' article');
    if (h.textContent.trim() !== txt) h.textContent = txt;
  }

  var etape2Ouverte = false;

  /* ---------- etape 2 : « complete ta routine » avant paiement ---------- */
  function panneau(cart) {
    var inner = document.querySelector('.cart-drawer .drawer__inner');
    if (!inner || !cart.items.length) return;
    /* on retire l'ancien bandeau du panier principal */
    document.querySelectorAll('.naqa-up-titre, .naqa-upsell-title, .naqa-up-zone:not(.naqa-step2__zone)').forEach(function (e) { e.remove(); });

    chargerProduits().then(function (list) {
      if (!list.length) return;
      var ids = cart.items.map(function (i) { return String(i.variant_id); });
      var cartes = list.map(function (p) {
        return vignette(p, ids.indexOf(String(p.variants[0].id)) > -1);
      }).join('');
      var p2 = document.querySelector('.naqa-step2');
      if (!p2) {
        p2 = document.createElement('div');
        p2.className = 'naqa-step2';
        p2.innerHTML =
          '<div class="naqa-step2__head">' +
            '<button type="button" class="naqa-step2__back" aria-label="Retour au panier">\u2190</button>' +
            '<p class="naqa-step2__title">compl\u00E8te ta routine</p>' +
          '</div>' +
          '<p class="naqa-step2__sub">Une derni\u00E8re envie avant de valider ?</p>' +
          '<div class="naqa-step2__zone naqa-up-zone"></div>' +
          '<div class="naqa-step2__foot">' +
            '<button type="button" class="naqa-step2__go">continuer vers le paiement</button>' +
            '<button type="button" class="naqa-step2__skip">non merci, je valide</button>' +
          '</div>';
        inner.appendChild(p2);
      }
      if (etape2Ouverte) p2.classList.add('is-open');
      var zone = p2.querySelector('.naqa-step2__zone');
      if (zone.dataset.naqaSig !== cartes.length + '_' + list.length) {
        zone.innerHTML = cartes;
        zone.dataset.naqaSig = cartes.length + '_' + list.length;
      }
      zone.querySelectorAll('.naqa-up-card').forEach(function (c) {
        if (ids.indexOf(String(c.dataset.id)) > -1) c.classList.add('naqa-in-cart');
        else c.classList.remove('naqa-in-cart');
      });
    });
  }

  function ouvrirEtape2() {
    var p2 = document.querySelector('.naqa-step2');
    if (!p2) return false;
    etape2Ouverte = true;
    p2.classList.add('is-open');
    return true;
  }
  function fermerEtape2() {
    etape2Ouverte = false;
    var p2 = document.querySelector('.naqa-step2');
    if (p2) p2.classList.remove('is-open');
  }

  var passe = false;
  document.addEventListener('click', function (e) {
    /* retour / fermeture */
    if (e.target.closest('.naqa-step2__back')) { e.preventDefault(); fermerEtape2(); return; }
    if (e.target.closest('.cart-drawer .drawer__close, .cart-drawer .drawer__overlay')) { fermerEtape2(); return; }
    /* aller au paiement */
    if (e.target.closest('.naqa-step2__go, .naqa-step2__skip')) {
      e.preventDefault();
      window.location.href = '/checkout';
      return;
    }
    /* interception du bouton de commande */
    var ck = e.target.closest('.cart-drawer .cart__checkout-button, .cart-drawer button[name="checkout"]');
    if (!ck || passe) return;
    var p2 = document.querySelector('.naqa-step2');
    var restants = p2 ? p2.querySelectorAll('.naqa-up-card:not(.naqa-in-cart)').length : 0;
    if (!p2 || !restants) return; /* rien a proposer : parcours normal */
    e.preventDefault();
    e.stopImmediatePropagation();
    ouvrirEtape2();
  }, true);

  /* ---------- ajout ---------- */
  var ajoutEnCours = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.naqa-up-add');
    if (!btn) return;
    e.preventDefault();
    if (ajoutEnCours) return;
    var carte = btn.closest('.naqa-up-card');
    var id = carte && carte.dataset.id;
    if (!id) return;
    ajoutEnCours = true;
    carte.classList.add('naqa-up-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function () {
        return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); });
      })
      .then(function (sections) {
        var cd = document.querySelector('cart-drawer');
        if (cd && sections && sections['cart-drawer'] && typeof cd.renderContents === 'function') {
          cd.renderContents({ sections: sections });
          if (typeof cd.open === 'function') cd.open();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {})
      .then(function () {
        carte.classList.remove('naqa-up-loading');
        setTimeout(function () { ajoutEnCours = false; }, 400);
        setTimeout(maj, 500);
      });
  });

  /* ---------- boucle unique ---------- */
  function maj() {
    if (enVol) return;
    if (!document.querySelector('cart-drawer')) return;
    enVol = true;
    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sig = cart.item_count + '|' + cart.total_price + '|' + JSON.stringify(cart.attributes || {}) + '|' + !!document.querySelector('.naqa-cart-giftpick');
        if (cart.items.length && !document.querySelector('.naqa-cart-giftpick') && window.__naqaGiftRender) {
          window.__naqaGiftRender();
          setTimeout(function () { paliers(cart.total_price || 0); etatCadeau(cart.attributes || {}); }, 150);
        }
        paliers(cart.total_price || 0);
        etatCadeau(cart.attributes || {});
        titrePanier(cart);
        panneau(cart);
        dernier = sig;
      })
      .catch(function () {})
      .then(function () { setTimeout(function () { enVol = false; }, 300); });
  }

  function planifier() {
    clearTimeout(minuteur);
    minuteur = setTimeout(maj, 500);
  }

  function demarrer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return setTimeout(demarrer, 600);
    maj();
    new MutationObserver(planifier).observe(cd, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest('#cart-icon-bubble, .cart-remove-button, .quantity__button, .naqa-gift__add')) {
        setTimeout(maj, 700);
      }
    });
    document.addEventListener('change', function (e) {
      if (e.target.closest('.naqa-gift__select')) setTimeout(maj, 150);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();


/* ============================================================
   SENTINELLE ESPACE CADEAU
   Le thème réécrit le contenu du panier à chaque changement de
   quantité / suppression : on remet l'espace cadeau s'il a saute.
   ============================================================ */
(function () {
  var enCours = false;
  setInterval(function () {
    if (enCours) return;
    var cd = document.querySelector('cart-drawer');
    if (!cd || !cd.classList.contains('active')) return;
    if (cd.classList.contains('is-empty')) return;
    if (document.querySelector('.naqa-cart-giftpick')) return;
    if (typeof window.__naqaGiftRender !== 'function') return;
    enCours = true;
    try { window.__naqaGiftRender(); } catch (e) {}
    setTimeout(function () { enCours = false; }, 800);
  }, 700);
})();


/* ============================================================
   LIBELLES DES BOUTONS (cartes produit + barre sticky)
   ============================================================ */
(function () {
  function libelles() {
    document.querySelectorAll('.quick-add__submit, .quick-add button[type="submit"]').forEach(function (b) {
      var t = (b.textContent || '').trim();
      if (!t || /^add to cart$/i.test(t)) {
        var aOptions = !!b.closest('.card-wrapper') && !!b.closest('.card-wrapper').querySelector('a[href*="/products/"]');
        b.textContent = 'Ajouter au panier';
      } else if (/choisir des options|choose options|select options/i.test(t)) {
        b.textContent = 'Choisir une option';
      }
    });
    document.querySelectorAll('.sticky-atc__label__text').forEach(function (s) {
      if (/^add to cart$/i.test((s.textContent || '').trim())) s.textContent = 'Ajouter au panier';
    });
  }
  var t = null;
  function planifier() { clearTimeout(t); t = setTimeout(libelles, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', libelles);
  else libelles();
  new MutationObserver(planifier).observe(document.body, { childList: true, subtree: true });
})();


/* ============================================================
   « COMPLETE TA ROUTINE » — liste facon Rhode (fiche produit)
   ============================================================ */
(function () {
  var bloc = null;

  function prix(c) { return (c / 100).toFixed(2).replace('.', ',') + ' \u20AC'; }

  function decoupe(titre) {
    var i = titre.indexOf(':');
    if (i === -1) return { t: titre, s: '' };
    return { t: titre.slice(0, i).trim(), s: titre.slice(i + 1).trim() };
  }

  function image(p) {
    var brut = p.featured_image || (p.images && p.images[0]) || '';
    if (typeof brut === 'object' && brut) brut = brut.src || '';
    if (brut.indexOf('//') === 0) brut = 'https:' + brut;
    return brut ? brut + (brut.indexOf('?') > -1 ? '&' : '?') + 'width=220' : '';
  }

  function ligne(p) {
    var d = decoupe(p.title);
    var v = p.variants[0];
    var options = '';
    if (p.variants.length > 1) {
      options = '<span class="naqa-rt__drop">' +
        '<select class="naqa-rt__select" aria-label="Choisir une option">' +
        p.variants.map(function (x) {
          return '<option value="' + x.id + '"' + (x.available ? '' : ' disabled') + '>' + x.title + '</option>';
        }).join('') + '</select></span>';
    }
    return '<label class="naqa-rt__row" data-id="' + v.id + '">' +
      '<input type="checkbox" class="naqa-rt__check">' +
      '<span class="naqa-rt__box" aria-hidden="true"></span>' +
      '<span class="naqa-rt__img"><img src="' + image(p) + '" alt="" loading="eager" decoding="async"></span>' +
      '<span class="naqa-rt__info">' +
        '<span class="naqa-rt__title">' + d.t + '</span>' +
        (d.s ? '<span class="naqa-rt__sub">' + d.s + '</span>' : '') +
        '<span class="naqa-rt__priceRow">' +
          '<span class="naqa-rt__price">' + prix(v.price) + '</span>' +
          options +
        '</span>' +
      '</span>' +
    '</label>';
  }

  function majBouton() {
    if (!bloc) return;
    var btn = bloc.querySelector('.naqa-rt__cta');
    var n = bloc.querySelectorAll('.naqa-rt__check:checked').length;
    if (!n) {
      btn.disabled = true;
      btn.textContent = 'S\u00E9lectionne un article';
    } else {
      btn.disabled = false;
      var total = 0;
      bloc.querySelectorAll('.naqa-rt__row').forEach(function (r) {
        var c = r.querySelector('.naqa-rt__check');
        if (c && c.checked) total += Number(r.dataset.prix || 0);
      });
      btn.textContent = 'Ajouter ' + n + (n > 1 ? ' articles' : ' article') + ' \u2014 ' + prix(total);
    }
  }

  function construire(produits, hote) {
    /* on vise la colonne de droite de la fiche produit */
    var colonne = document.querySelector('.product__info-container') ||
                  document.querySelector('.product__info-wrapper');
    if (colonne) hote = colonne;
    bloc = document.createElement('div');
    bloc.className = colonne ? 'naqa-rt naqa-rt--colonne' : 'naqa-rt page-width';
    bloc.innerHTML =
      '<h2 class="naqa-rt__heading">compl\u00E8te ta routine</h2>' +
      '<div class="naqa-rt__list">' + produits.map(ligne).join('') + '</div>' +
      '<div class="naqa-rt__footer">' +
      '<button type="button" class="naqa-rt__cta" disabled>s\u00E9lectionne un article</button></div>';
    document.querySelectorAll('.naqa-rt').forEach(function (e) { e.remove(); });
    if (!bloc.classList.contains('naqa-rt--colonne')) {
      hote.innerHTML = '';
      hote.appendChild(bloc);
    } else {
      /* on se cale juste apres le bouton d'achat et les moyens de paiement */
      var btn = hote.querySelector('.main-product-atc, .product-form__submit, button[name="add"]');
      var ancre = btn;
      while (ancre && ancre.parentElement !== hote) ancre = ancre.parentElement;
      /* on saute les blocs d'applis qui suivent (Scalapay, etc.) */
      while (ancre && ancre.nextElementSibling &&
             ancre.nextElementSibling.classList.contains('shopify-app-block')) {
        ancre = ancre.nextElementSibling;
      }
      if (ancre && ancre.nextElementSibling) hote.insertBefore(bloc, ancre.nextElementSibling);
      else hote.appendChild(bloc);
    }
    /* la section « produits recommandes » devient inutile */
    var reco = document.querySelector('product-recommendations');
    var sec = reco ? reco.closest('section') : null;
    if (sec && bloc.classList.contains('naqa-rt--colonne')) sec.style.display = 'none';

    /* prix memorise sur chaque ligne */
    bloc.querySelectorAll('.naqa-rt__row').forEach(function (r, i) {
      r.dataset.prix = produits[i].variants[0].price;
    });

    bloc.addEventListener('change', function (e) {
      var r = e.target.closest('.naqa-rt__row');
      if (!r) return;
      if (e.target.classList.contains('naqa-rt__select')) {
        var p = produits[Array.prototype.indexOf.call(bloc.querySelectorAll('.naqa-rt__row'), r)];
        var v = p.variants.filter(function (x) { return String(x.id) === e.target.value; })[0];
        if (v) {
          r.dataset.id = v.id;
          r.dataset.prix = v.price;
          r.querySelector('.naqa-rt__price').textContent = prix(v.price);
        }
      }
      if (e.target.classList.contains('naqa-rt__check')) {
        r.classList.toggle('is-checked', e.target.checked);
        var boite = r.querySelector('.naqa-rt__box');
        if (boite) {
          if (e.target.checked) {
            boite.style.setProperty('background', '#FFB9D5', 'important');
            boite.style.setProperty('border-color', '#FFB9D5', 'important');
            boite.textContent = '\u2713';
            boite.style.setProperty('color', '#FFFFFF', 'important');
            boite.style.setProperty('display', 'flex', 'important');
            boite.style.setProperty('align-items', 'center', 'important');
            boite.style.setProperty('justify-content', 'center', 'important');
            boite.style.setProperty('font-size', '14px', 'important');
          } else {
            boite.removeAttribute('style');
            boite.textContent = '';
          }
        }
      }
      majBouton();
    });

    bloc.querySelector('.naqa-rt__cta').addEventListener('click', function () {
      var items = [];
      bloc.querySelectorAll('.naqa-rt__row').forEach(function (r) {
        var c = r.querySelector('.naqa-rt__check');
        if (c && c.checked) items.push({ id: Number(r.dataset.id), quantity: 1 });
      });
      if (!items.length) return;
      var btn = bloc.querySelector('.naqa-rt__cta');
      btn.disabled = true;
      btn.textContent = 'Ajout en cours\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function () {
          return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { accept: 'application/json' }, cache: 'no-store' })
            .then(function (r) { return r.json(); });
        })
        .then(function (sections) {
          var cd = document.querySelector('cart-drawer');
          if (cd && sections && sections['cart-drawer'] && typeof cd.renderContents === 'function') {
            cd.renderContents({ sections: sections });
            if (typeof cd.open === 'function') cd.open();
          } else {
            window.location.reload();
          }
          bloc.querySelectorAll('.naqa-rt__check').forEach(function (c) { c.checked = false; });
          bloc.querySelectorAll('.naqa-rt__row').forEach(function (r) { r.classList.remove('is-checked'); });
          majBouton();
        })
        .catch(function () { majBouton(); });
    });
  }

  var enConstruction = false;
  function demarrer() {
    var hote = document.querySelector('product-recommendations');
    if (!hote || enConstruction) return;
    if (document.querySelector('.naqa-rt')) return;
    enConstruction = true;
    setTimeout(function () { enConstruction = false; }, 1500);
    var pid = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product
      ? ShopifyAnalytics.meta.product.id : null;
    if (!pid) { enConstruction = false; return; }

    function reco(intent, limit) {
      return fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + limit + '&intent=' + intent, { headers: { accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    }

    reco('complementary', 4).then(function (a) {
      if (a.length >= 4) return a;
      return reco('related', 6).then(function (b) {
        var vus = {};
        a.forEach(function (p) { vus[p.id] = 1; });
        b.forEach(function (p) { if (!vus[p.id] && a.length < 4) { vus[p.id] = 1; a.push(p); } });
        return a;
      });
    }).then(function (produits) {
      if (!produits.length) return;
      construire(produits.slice(0, 4), hote);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
  setTimeout(demarrer, 1200);
  setTimeout(demarrer, 3000);
})();

/* ============================================================
   BOUTON PRINCIPAL : « ACHETER — 29,90 € »
   ============================================================ */
(function () {
  function formate(c) {
    return (c / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }
  function prixCourant() { if (!/\/products\//.test(location.pathname)) return "";
    /* 1) variante selectionnee dans le formulaire */
    var meta = false && window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    var champ = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (meta && meta.variants && champ && champ.value) {
      var v = meta.variants.filter(function (x) { return String(x.id) === String(champ.value); })[0];
      if (v && typeof v.price === 'number') return formate(v.price);
    }
    /* 2) repli : prix affiche dans la colonne produit */
    var zone = document.querySelector('.product__info-wrapper, .product__info-container') || document;
    var el = zone.querySelector('.price__container .price-item--sale:not(.hidden), .price__container .price-item--regular, .price-item--regular');
    return el ? el.textContent.trim().replace(/\s+/g, ' ') : '';
  }
  function maj() {
    var boutons = document.querySelectorAll('.main-product-atc, .product-form__submit, button[name="add"], .sticky-atc__btn');
    var p = prixCourant();
    if (!p) return;
    var txt = 'Acheter \u2014 ' + p;
    boutons.forEach(function (b) {
      var lab = b.querySelector('.main-atc__label, .button__label, .sticky-atc__label__text') || b;
      if (lab.textContent.trim() !== txt) lab.textContent = txt;
    });
  }
  var t = null;
  function planifier() { clearTimeout(t); t = setTimeout(maj, 200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maj);
  else maj();
  new MutationObserver(planifier).observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('change', planifier);
  setTimeout(maj, 1500);
})();


/* ============================================================
   SYNCHRO DES LIGNES CADEAU (produits a 0 EUR)
   Le cadeau choisi devient une vraie ligne du panier.
   ============================================================ */
(function () {
  var SEUIL_OFFERT = 4000;
  var SEUIL_CADEAU = 20000;
  var CADEAU_IDS = {
    'la sticker card': 54410566238554,
    'l\u2019\u00E9chantillon 2 gummies': 54410568171866,
    'le tote bag': 54410568302938,
    'la trousse naq\u00E4': 54410568368474
  };
  var TOUS = Object.keys(CADEAU_IDS).map(function (k) { return CADEAU_IDS[k]; });
  var PALIER = {};
  PALIER[54410566238554] = SEUIL_OFFERT;
  PALIER[54410568171866] = SEUIL_OFFERT;
  PALIER[54410568302938] = SEUIL_CADEAU;
  PALIER[54410568368474] = SEUIL_CADEAU;

  var occupe = false;

  function rendu() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var cd = document.querySelector('cart-drawer');
        if (cd && sections && sections['cart-drawer'] && typeof cd.renderContents === 'function') {
          cd.renderContents({ sections: sections });
        }
      })
      .catch(function () {});
  }

  function synchro() {
    if (occupe) return;
    occupe = true;
    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = cart.attributes || {};
        /* ancien attribut, on le nettoie pour ne pas polluer la commande */
        if (a['Cadeau sticker']) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Cadeau sticker': '' } })
          });
        }

        /* total hors cadeaux */
        var total = 0;
        cart.items.forEach(function (i) {
          if (TOUS.indexOf(i.variant_id) === -1) total += i.line_price;
        });

        /* jusqu'a deux cadeaux : l'offert des 40 EUR, le 2e des 200 EUR */
        var attendus = [];
        var idOffert = CADEAU_IDS[a['Cadeau offert'] || ''] || null;
        if (idOffert && total >= SEUIL_OFFERT) attendus.push(idOffert);
        var idCadeau = CADEAU_IDS[a['Cadeau'] || ''] || null;
        if (idCadeau && total >= SEUIL_CADEAU) attendus.push(idCadeau);

        var presents = cart.items.filter(function (i) { return TOUS.indexOf(i.variant_id) > -1; });
        var aRetirer = presents.filter(function (i) { return attendus.indexOf(i.variant_id) === -1; });
        var aAjouter = attendus.filter(function (id) {
          return !presents.some(function (i) { return i.variant_id === id; });
        });

        var chaine = Promise.resolve();
        aRetirer.forEach(function (i) {
          chaine = chaine.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: String(i.key), quantity: 0 })
            });
          });
        });
        if (aAjouter.length) {
          chaine = chaine.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: aAjouter.map(function (id) { return { id: id, quantity: 1 }; }) })
            });
          });
        }
        if (!aRetirer.length && !aAjouter.length) return null;
        return chaine.then(rendu);
      })
      .catch(function () {})
      .then(function () { setTimeout(function () { occupe = false; }, 600); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.naqa-gift__add')) setTimeout(synchro, 900);
    if (e.target.closest('.cart-remove-button, .quantity__button, .naqa-up-add, .naqa-rt__cta')) setTimeout(synchro, 1400);
  });
  document.addEventListener('DOMContentLoaded', function () { setTimeout(synchro, 2000); });
  setTimeout(synchro, 2500);
})();


/* ============================================================
   SECTION « UTILISATION » — mise en page facon Kylie
   carte gauche : signature + visuel + accroche
   carte droite : deux visuels + « comment l'utiliser » + etapes
   ============================================================ */
(function () {
  function trouverConseils() {
    var strict = null, large = null;
    document.querySelectorAll('details, .accordion').forEach(function (d) {
      var t = (d.querySelector('summary, .accordion__title') || {}).innerText || '';
      var corps = d.querySelector('.accordion__content, .rte, .product__accordion-content');
      var txt = corps ? (corps.innerText || '').trim() : '';
      if (txt.length <= 40) return;
      if (!strict && /conseils? d.?utilisation|mode d.?emploi/i.test(t)) strict = { bloc: d, texte: txt };
      if (!large && /utilisation|application|comment l.?utiliser/i.test(t)) large = { bloc: d, texte: txt };
    });
    return strict || large;
  }

  function decouper(texte) {
    var phrases = texte.replace(/\s+/g, ' ').split(/(?<=[.!?])\s+/)
      .map(function (p) { return p.trim(); })
      .filter(function (p) { return p.length > 15; });
    if (phrases.length < 2) return null;
    if (phrases.length <= 3) return phrases;
    var taille = Math.ceil(phrases.length / 3);
    var out = [];
    for (var i = 0; i < 3; i++) out.push(phrases.slice(i * taille, (i + 1) * taille).join(' '));
    return out.filter(function (e) { return e.length; });
  }

  function imagesProduit() {
    var imgs = [];
    document.querySelectorAll('.product__media-item img').forEach(function (im) {
      var s = im.currentSrc || im.src;
      if (s) imgs.push(s);
    });
    return imgs;
  }

  /* videos « comment l'utiliser » choisies produit par produit */
  var VIDEO_CURLY = 'https://cdn.shopify.com/videos/c/o/v/04baee1b396a488490d83d201757eaff.mp4';
  var VIDEOS_UTILISATION = {
    'shampooing-hydratant-cheveux-boucles-good-curls': VIDEO_CURLY,
    'apres-shampooing-demealant-cheveux-boucles-good-curls': VIDEO_CURLY,
    'brosse-demealante-definition-cheveux-boucles-sculptor-brush': VIDEO_CURLY,
    'coffret-routine-curly-complete-cheveux-boucles-dreamy-curls': VIDEO_CURLY,
    'soin-sans-rincage-double-texture-gelee-creme-boucles-jelly-milky': VIDEO_CURLY
  };

  /* textes de mode d'emploi ecrits sur mesure pour certains produits */
  var SUR_MESURE = {
    'gummies-collagene-verisol-peau-cheveux-ongles-halal': [
      'Deux gummies par jour, \u00E0 croquer au moment qui te convient.',
      'Id\u00E9alement en cure intensive de trois mois, le temps que le collag\u00E8ne agisse en profondeur.',
      'Ensuite, une cure d\u2019entretien dans les p\u00E9riodes de stress ou aux changements de saison.'
    ]
  };

  function construire() {
    if (document.querySelector('.naqa-app')) return;
    var handleCourant = (window.location.pathname.split('/products/')[1] || '').split('?')[0];
    var infos = trouverConseils();
    var etapes = SUR_MESURE[handleCourant] || null;
    if (!etapes) {
      if (!infos) return;
      etapes = decouper(infos.texte);
    }
    if (!etapes || etapes.length < 2) return;
    var imgs = imagesProduit();
    if (imgs.length < 2) return;

    var principal = document.querySelector('section.shopify-section[id*="__main"]') ||
                    document.querySelector('section[id*="__main"]');
    if (!principal) return;
    while (principal.parentElement && principal.parentElement.tagName !== 'MAIN' &&
           principal.parentElement.tagName !== 'BODY') {
      principal = principal.parentElement;
    }

    var titre = (document.querySelector('.product__title h1, h1') || {}).innerText || '';
    var accroche = '';
    var puce = document.querySelector('.product__info-container strong');
    if (puce) accroche = puce.textContent.trim();
    if (!accroche) accroche = titre.split(':').slice(1).join(':').trim() || titre;

    var v1 = imgs[1] || imgs[0];
    var v2 = imgs[2] || imgs[0];
    var v3 = imgs[3] || imgs[2] || imgs[0];

    var sec = document.createElement('div');
    sec.className = 'naqa-app page-width';
    sec.dataset.v2 = (imgs[2] || imgs[0]);
    sec.innerHTML =
      '<div class="naqa-app__carte naqa-app__carte--gauche">' +
        '<div class="naqa-app__hero"><img src="' + v1 + '" alt=""></div>' +
      '</div>' +
      '<div class="naqa-app__carte naqa-app__carte--droite">' +
        '<div class="naqa-app__duo">' +
          '<div class="naqa-app__vignette"><img src="' + v2 + '" alt=""></div>' +
        '</div>' +
        '<p class="naqa-app__titre">Comment l\u2019utiliser</p>' +
        '<div class="naqa-app__etapes">' +
          etapes.map(function (t) { return '<p class="naqa-app__etape">' + t + '</p>'; }).join('') +
        '</div>' +
      '</div>';

    principal.parentNode.insertBefore(sec, principal.nextSibling);
    if (infos && infos.bloc) infos.bloc.style.display = 'none';

    var handle = (window.location.pathname.split('/products/')[1] || '').split('?')[0];
    if (!handle) return;

    /* video dediee pour ce produit */
    if (VIDEOS_UTILISATION[handle]) {
      var caseVid = sec.querySelector('.naqa-app__duo .naqa-app__vignette');
      if (caseVid) {
        caseVid.innerHTML = '<video src="' + VIDEOS_UTILISATION[handle] +
          '" autoplay muted loop playsinline preload="metadata"></video>';
      }
      return;
    }

    /* sinon : video de la galerie si elle existe */
    fetch('/products/' + handle + '.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var vid = (p.media || []).filter(function (m) {
          return m.media_type === 'video' && m.sources && m.sources.length;
        })[0];
        if (!vid) return;
        var mp4 = vid.sources.filter(function (s) { return /mp4/i.test(s.format || s.mime_type || ''); })[0] || vid.sources[0];
        if (!mp4 || !mp4.url) return;
        var case1 = sec.querySelector('.naqa-app__duo .naqa-app__vignette');
        if (!case1) return;
        case1.innerHTML = '<video src="' + mp4.url + '" autoplay muted loop playsinline preload="metadata"></video>';
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', construire);
  else construire();
  var essaisUtil = 0;
  var boucleUtil = setInterval(function () {
    essaisUtil++;
    try { construire(); } catch (e) {}
    if (document.querySelector('.naqa-app') || essaisUtil > 40) clearInterval(boucleUtil);
  }, 600);
  window.addEventListener('load', construire);
})();

/* ============================================================
   GALERIE : GLISSEMENT lateral au clic sur une vignette
   (le thème ne faisait pas defiler la liste)
   ============================================================ */
(function () {
  function liste() { return document.querySelector('.product__media-list'); }

  function versIndex(i) {
    var l = liste();
    if (!l) return;
    var items = l.querySelectorAll('.product__media-item');
    if (!items[i]) return;
    l.scrollTo({ left: items[i].offsetLeft - l.offsetLeft, behavior: 'smooth' });
    document.querySelectorAll('.thumbnail-list__item .thumbnail').forEach(function (t, n) {
      t.classList.toggle('is-active', n === i);
      t.setAttribute('aria-current', n === i ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('.thumbnail-list__item .thumbnail');
    if (!t) return;
    var item = t.closest('.thumbnail-list__item');
    var tous = Array.prototype.slice.call(document.querySelectorAll('.thumbnail-list__item'));
    var i = tous.indexOf(item);
    if (i > -1) setTimeout(function () { versIndex(i); }, 10);
  });

  /* la vignette active suit le defilement manuel / les fleches */
  function suivre() {
    var l = liste();
    if (!l) return;
    var items = l.querySelectorAll('.product__media-item');
    var i = 0, min = Infinity;
    items.forEach(function (it, n) {
      var d = Math.abs(it.offsetLeft - l.offsetLeft - l.scrollLeft);
      if (d < min) { min = d; i = n; }
    });
    document.querySelectorAll('.thumbnail-list__item .thumbnail').forEach(function (t, n) {
      t.classList.toggle('is-active', n === i);
    });
  }
  function demarrer() {
    var l = liste();
    if (!l) return setTimeout(demarrer, 600);
    var t = null;
    l.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(suivre, 120); });
    suivre();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();


/* ============================================================
   BARRE DE REASSURANCE (fiche produit, sous le bouton d'achat)
   ============================================================ */
(function () {
  var POINTS = [
    { i: 'M3 8h11v7H3zM14 10h4l3 3v2h-7z M6.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z M17.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z', t: 'Livraison offerte', s: 'd\u00E8s 80 \u20AC' },
    { i: 'M12 3a9 9 0 1 0 9 9h-2a7 7 0 1 1-7-7zM12 7v5l4 2', t: 'Exp\u00E9di\u00E9 sous 48 h', s: 'depuis la France' },
    { i: 'M3 6h18v12H3zM3 10h18M7 15h4', t: 'Paiement en 4\u00D7', s: 'sans frais' },
    { i: 'M9 14l-4-4 4-4M5 10h9a5 5 0 0 1 0 10h-3', t: 'Retours 14 jours', s: 'satisfaite ou rembours\u00E9e' }
  ];

  function construire() {
    var col = document.querySelector('.product__info-container');
    if (!col) return;
    var existant = document.querySelector('.naqa-trust');
    var routine = col.querySelector('.naqa-rt');
    if (existant) {
      /* la reassurance doit toujours preceder « complete ta routine » */
      if (routine && existant.nextElementSibling !== routine) col.insertBefore(existant, routine);
      return;
    }
    var btn = col.querySelector('.main-product-atc, .product-form__submit, button[name="add"]');
    if (!btn) return;

    var bloc = document.createElement('div');
    bloc.className = 'naqa-trust';
    bloc.innerHTML = POINTS.map(function (p) {
      return '<div class="naqa-trust__item">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="' + p.i + '"/></svg>' +
        '<span><strong>' + p.t + '</strong><em>' + p.s + '</em></span>' +
      '</div>';
    }).join('');

    /* juste avant « complete ta routine », donc apres le bouton et Scalapay */
    if (routine) {
      col.insertBefore(bloc, routine);
      return;
    }
    var ancre = btn;
    while (ancre && ancre.parentElement !== col) ancre = ancre.parentElement;
    while (ancre && ancre.nextElementSibling && ancre.nextElementSibling.classList.contains('shopify-app-block')) {
      ancre = ancre.nextElementSibling;
    }
    if (ancre && ancre.nextElementSibling) col.insertBefore(bloc, ancre.nextElementSibling);
    else col.appendChild(bloc);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', construire);
  else construire();
  setTimeout(construire, 1500);
  setTimeout(construire, 3200);
})();


/* ============================================================
   FAQ FACON RHODE : panneau rose a gauche, grand visuel a droite
   ============================================================ */
(function () {
  function construire() {
    var sec = document.querySelector('section[id*="collapsible_content"]');
    if (!sec || sec.dataset.naqaFaq === '1') return;
    var interne = sec.querySelector('.collapsible-content-wrapper-narrow, .collapsible-content__wrapper');
    if (!interne) return;

    /* visuel : la derniere image de la galerie produit */
    var imgs = [];
    document.querySelectorAll('.product__media-item img').forEach(function (im) {
      var s = im.currentSrc || im.src;
      if (s) imgs.push(s);
    });
    if (!imgs.length) return;
    var visuel = imgs[imgs.length - 1];

    sec.dataset.naqaFaq = '1';
    sec.classList.add('naqa-faq');

    var grille = document.createElement('div');
    grille.className = 'naqa-faq__grid page-width';

    var gauche = document.createElement('div');
    gauche.className = 'naqa-faq__gauche';

    var droite = document.createElement('div');
    droite.className = 'naqa-faq__visuel';
    droite.innerHTML = '<img src="' + visuel + '" alt="">';

    var parent = interne.parentNode;
    parent.insertBefore(grille, interne);
    gauche.appendChild(interne);
    grille.appendChild(gauche);
    grille.appendChild(droite);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', construire);
  else construire();
  var essaisApp = 0;
  var boucleApp = setInterval(function () {
    essaisApp++;
    try { construire(); } catch (e) { window.__naqaAppErr = String(e && e.message); }
    if (document.querySelector('.naqa-app') || essaisApp > 60) clearInterval(boucleApp);
  }, 700);
})();


/* ============================================================
   « POURQUOI ON L'ADORE » — fusion composition + benefices (facon Kylie)
   ============================================================ */
(function () {
  function construire() {
    if (document.querySelector('.naqa-why')) return;
    var multi = document.querySelector('section[id*="multicolumn"]');
    if (!multi) return;

    /* ingredients : titres + descriptions de la section composition */
    var ingredients = [];
    multi.querySelectorAll('.multicolumn-list__item, li').forEach(function (c) {
      var h = c.querySelector('h3, h4, .multicolumn-card__title');
      var p = c.querySelector('p, .rte');
      if (!h) return;
      ingredients.push({
        nom: h.innerText.trim(),
        txt: p ? p.innerText.trim() : ''
      });
    });
    if (ingredients.length < 2) return;

    /* avantages : les puces de la colonne produit */
    var avantages = [];
    var col = document.querySelector('.product__info-container');
    if (col) {
      col.querySelectorAll('div.metafield-rich_text_field').forEach(function (d) {
        var t = (d.innerText || '').trim().replace(/\s+/g, ' ');
        if (t.length <= 15 || t.length >= 220 || avantages.length >= 3) return;
        var gras = d.querySelector('strong');
        var titre = gras ? gras.textContent.trim() : t.split(/[,.]/)[0].trim();
        avantages.push({ titre: titre, desc: t });
      });
    }
    if (!avantages.length) return;

    var imgs = [];
    document.querySelectorAll('.product__media-item img').forEach(function (im) {
      var s = im.currentSrc || im.src;
      if (s) imgs.push(s);
    });
    var visuel = imgs[2] || imgs[1] || imgs[0];
    if (!visuel) return;

    var sec = document.createElement('div');
    sec.className = 'naqa-why page-width';
    sec.innerHTML =
      '<div class="naqa-why__carte">' +
        '<p class="naqa-why__titre">pourquoi on l\u2019adore</p>' +
        '<div class="naqa-why__cols">' +
          '<div class="naqa-why__col">' +
            '<p class="naqa-why__sous">ingr\u00E9dients cl\u00E9s</p>' +
            ingredients.slice(0, 3).map(function (i) {
              return '<p class="naqa-why__nom">' + i.nom.toLowerCase() + '</p>' +
                     '<p class="naqa-why__desc">' + i.txt + '</p>';
            }).join('') +
          '</div>' +
          '<div class="naqa-why__col">' +
            '<p class="naqa-why__sous">avantages</p>' +
            avantages.slice(0, 3).map(function (a) {
              return '<p class="naqa-why__nom">' + a.titre + '</p>' +
                     '<p class="naqa-why__desc">' + a.desc + '</p>';
            }).join('') +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="naqa-why__visuel"><img src="' + visuel + '" alt=""></div>';

    /* juste apres la section « Utilisation » si elle existe */
    var app = document.querySelector('.naqa-app');
    if (app && app.parentNode) app.parentNode.insertBefore(sec, app.nextSibling);
    else multi.parentNode.insertBefore(sec, multi);
    multi.style.display = 'none';
  }

  /* si « Utilisation » arrive apres coup, on se recale dessous */
  setInterval(function () {
    var app = document.querySelector('.naqa-app');
    var why = document.querySelector('.naqa-why');
    if (app && why && app.nextElementSibling !== why && app.parentNode) {
      app.parentNode.insertBefore(why, app.nextSibling);
    }
  }, 800);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', construire);
  else construire();
  var n = 0;
  var b = setInterval(function () {
    n++;
    try { construire(); } catch (e) {}
    if (document.querySelector('.naqa-why') || n > 40) clearInterval(b);
  }, 600);
})();


/* ============================================================
   MASQUER « POURQUOI <produit> ? » (remplacee par « pourquoi on l'adore »)
   ============================================================ */
(function () {
  function masquer() {
    document.querySelectorAll('h1, h2, h3').forEach(function (h) {
      if (h.closest('.naqa-why')) return;
      var t = (h.textContent || '').trim();
      if (!/^pourquoi\s+\S/i.test(t)) return;
      var bloc = h.closest('.custom-columns');
      if (bloc) {
        var enveloppe = bloc.closest('div.gradient') || bloc.parentElement || bloc;
        enveloppe.style.display = 'none';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', masquer);
  else masquer();
  var n = 0;
  var b = setInterval(function () { n++; masquer(); if (n > 20) clearInterval(b); }, 700);
})();


/* ============================================================
   EN-TETE FICHE PRODUIT : titre + sous-titre + badge best seller
   ============================================================ */
(function () {
  function construire() {
    var bloc = document.querySelector('.product__info-container .product__title');
    if (!bloc || bloc.dataset.naqaTitre === '1') return;
    var h1 = bloc.querySelector('h1');
    if (!h1) return;
    var texte = (h1.innerText || '').trim();
    if (!texte) return;
    bloc.dataset.naqaTitre = '1';

    var i = texte.indexOf(':');
    var titre = i > -1 ? texte.slice(0, i).trim() : texte;
    var sous = i > -1 ? texte.slice(i + 1).trim() : '';

    h1.textContent = titre;

    if (sous) {
      var p = document.createElement('p');
      p.className = 'naqa-head__sub';
      p.textContent = sous;
      bloc.appendChild(p);
    }

  }

  /* badge « best seller » : etiquette produit « best-seller » ou mention sur la page */
  var badgeFait = false;
  function poserBadge() {
    var bloc = document.querySelector('.product__info-container .product__title');
    if (!bloc || bloc.querySelector('.naqa-head__badge')) return;
    var b = document.createElement('span');
    b.className = 'naqa-head__badge';
    b.textContent = 'best seller';
    bloc.insertBefore(b, bloc.firstChild);
  }
  function badge() {
    if (badgeFait) return;
    var col = document.querySelector('.product__info-container');
    if (!col) return;
    var best = false;
    col.querySelectorAll('*').forEach(function (e) {
      if (e.children.length) return;
      if (/best[\s-]?seller/i.test(e.textContent || '')) best = true;
    });
    if (best) { badgeFait = true; poserBadge(); return; }
    badgeFait = true;
    var handle = (window.location.pathname.split('/products/')[1] || '').split('?')[0];
    if (!handle) return;

    /* 1) etiquette du produit */
    fetch('/products/' + handle + '.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var tags = (p.tags || []).join(' ');
        if (/best[\s-]?seller|bestseller/i.test(tags)) { poserBadge(); return null; }
        /* 2) sinon : appartenance a la collection « meilleures ventes » */
        return fetch('/collections/meilleures-ventes/products.json?limit=250', { headers: { accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var dedans = (c.products || []).some(function (x) { return x.handle === handle; });
            if (dedans) poserBadge();
          });
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', construire);
  else construire();
  var n = 0;
  var t = setInterval(function () {
    n++;
    construire();
    badge();
    if (n > 20) clearInterval(t);
  }, 600);
})();


/* ============================================================
   ICONES DES ARGUMENTS (fiche produit)
   une icone qui colle au sens de la phrase, a la place du check
   ============================================================ */
(function () {
  var D = { fill: 'none', sw: '1.6' };

  var ICONES = [
    { mots: /hydrat|humide|eau|soif/i, path: 'M12 3s6 6.5 6 10.5a6 6 0 0 1-12 0C6 9.5 12 3 12 3z' },                 /* goutte */
    { mots: /boucle|d\u00E9fini|ressort|frisott|curl|ondul/i, path: 'M4 9c2-3 5-3 7 0s5 3 7 0M4 15c2-3 5-3 7 0s5 3 7 0' }, /* vagues */
    { mots: /naturel|ingr\u00E9dient|bio|v\u00E9g\u00E9tal|plante|clean/i, path: 'M20 4c0 8-5 13-13 13M7 17c0-6 4-10 10-11M4 20c1-1 2-2 3-3' }, /* feuille */
    { mots: /ph|\u00E9quilibr|balance/i, path: 'M12 3v18M5 8h14M7 8l-3 6a3 3 0 0 0 6 0L7 8zM17 8l-3 6a3 3 0 0 0 6 0l-3-6z' }, /* balance */
    { mots: /doux|douce|sans sulfate|respect|apaise|sensible/i, path: 'M20 4c0 0-9 1-13 5s-3 11-3 11 7-1 11-5 5-11 5-11z M4 20c3-3 6-6 10-8' }, /* plume */
    { mots: /brillance|\u00E9clat|lumi|glow|shine/i, path: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z' }, /* etincelle */
    { mots: /prot\u00E9g|protection|barri\u00E8re|casse|abim/i, path: 'M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z' },  /* bouclier */
    { mots: /nuit|sommeil|dormir|satin|soie/i, path: 'M20 14a8 8 0 1 1-10-10 7 7 0 0 0 10 10z' },                       /* lune */
    { mots: /parfum|senteur|odeur|fleur|monoi|mono\u00EF/i, path: 'M12 4c2 0 3 1.5 3 3s-1 3-3 3-3-1.5-3-3 1-3 3-3zM12 10v10M8 14c-2 0-3-1-3-2.5S6 9 8 9M16 14c2 0 3-1 3-2.5S18 9 16 9' }, /* fleur */
    { mots: /peau|visage|teint|pore/i, path: 'M12 3a9 9 0 1 0 9 9 9 9 0 0 0-9-9zM9 10h.01M15 10h.01M9 15c1.5 1 4.5 1 6 0' }, /* visage */
    { mots: /collag|gummies|cure|complement|compl\u00E9ment|ongle/i, path: 'M4 15l7-7a4 4 0 0 1 6 6l-7 7a4 4 0 0 1-6-6zM8 11l5 5' }, /* gelule */
    { mots: /france|europe|fabriqu|labo/i, path: 'M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11zM12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z' } /* lieu */
  ];
  var DEFAUT = 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z';

  function svg(path) {
    return '<svg class="naqa-arg__icone" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
           'stroke-width="' + D.sw + '" stroke-linecap="round" stroke-linejoin="round"><path d="' + path + '"/></svg>';
  }

  function choisir(texte) {
    for (var i = 0; i < ICONES.length; i++) {
      if (ICONES[i].mots.test(texte)) return ICONES[i].path;
    }
    return DEFAUT;
  }

  function poser() {
    var col = document.querySelector('.product__info-container');
    if (!col) return;
    col.querySelectorAll('div.metafield-rich_text_field').forEach(function (d) {
      var ligne = d.closest('div');
      var parent = d.parentElement && d.parentElement.parentElement;
      if (!parent) return;
      var icone = parent.querySelector('.material-icon');
      if (!icone || icone.dataset.naqa === '1') return;
      var texte = (d.innerText || '').trim();
      icone.dataset.naqa = '1';
      icone.classList.add('naqa-arg__wrap');
      icone.innerHTML = svg(choisir(texte));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poser);
  else poser();
  var n = 0;
  var t = setInterval(function () { n++; poser(); if (n > 20) clearInterval(t); }, 600);
})();


/* ============================================================
   GLOW EN MAJUSCULES (seule exception a la regle minuscules)
   + zoom sur la ligne survolee du comparatif
   ============================================================ */
(function () {
  function majGlow() {
    var cibles = document.querySelectorAll(
      '.product__title h1, .naqa-head__sub, .naqa-koia__title, .naqa-rt__title, .naqa-app__titre, .naqa-why__titre'
    );
    cibles.forEach(function (e) {
      if (e.dataset.naqaGlow === '1') return;
      if (!/glow/i.test(e.textContent || '')) return;
      e.dataset.naqaGlow = '1';
      if (/secret\s*glow/i.test(e.textContent)) return;
      e.innerHTML = e.innerHTML.replace(/glow/gi, '<span class="naqa-maj">GLOW</span>');
    });
  }

  function tout() { majGlow(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
  var n = 0;
  var t = setInterval(function () { n++; tout(); if (n > 25) clearInterval(t); }, 600);
})();





/* ============================================================
   ICONES : JAMAIS DEUX FOIS LA MEME (Lea)
   ============================================================ */
(function () {
  var SVG = 'http://www.w3.org/2000/svg';
  var RESERVE = [
    '<path d="M12 3l2.2 5.6L20 9.6l-4 3.9 1 5.7-5-2.9-5 2.9 1-5.7-4-3.9 5.8-1z"/>',
    '<path d="M12 21s-7-4.6-7-9.4A4 4 0 0 1 12 8a4 4 0 0 1 7 3.6C19 16.4 12 21 12 21z"/>',
    '<path d="M12 3l7 3v5c0 4.4-3 8.2-7 10-4-1.8-7-5.6-7-10V6z"/>',
    '<path d="M12 2v4M12 18v4M4.9 4.9l2.9 2.9M16.2 16.2l2.9 2.9M2 12h4M18 12h4M4.9 19.1l2.9-2.9M16.2 7.8l2.9-2.9"/>',
    '<path d="M20 12a8 8 0 1 1-8-8 6 6 0 0 0 8 8z"/>',
    '<path d="M6 3h12M6 21h12M8 3v4c0 2 4 3 4 5s-4 3-4 5v4M16 3v4c0 2-4 3-4 5s4 3 4 5v4"/>',
    '<path d="M4 19V5M4 19h16M8 15l3-4 3 3 5-7"/>',
    '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/>',
    '<path d="M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2zM9 20h6M10 22h4"/>',
    '<path d="M3 12h4l3 7 4-14 3 7h4"/>'
  ];

  function signature(svg) {
    return (svg.innerHTML || '').replace(/\s+/g, '');
  }

  function neuf(corps) {
    var s = document.createElementNS(SVG, 'svg');
    s.setAttribute('class', 'naqa-arg__icone');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '1.6');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    s.innerHTML = corps;
    return s;
  }

  function dedoublonner() {
    document.querySelectorAll('.product__text-container').forEach(function (bloc) {
      var icones = bloc.querySelectorAll('.naqa-arg__icone');
      if (icones.length < 2) return;
      var vues = {};
      var libres = RESERVE.slice();
      icones.forEach(function (ic) { vues[signature(ic)] = 1; });
      icones.forEach(function (ic) {
        var sig = signature(ic);
        if (vues[sig] === 1) { vues[sig] = 2; return; }
        var corps = null;
        for (var i = 0; i < libres.length; i++) {
          var test = libres[i].replace(/\s+/g, '');
          if (!vues[test]) { corps = libres[i]; libres.splice(i, 1); break; }
        }
        if (!corps) return;
        var remplacant = neuf(corps);
        vues[signature(remplacant)] = 2;
        ic.replaceWith(remplacant);
      });
    });
  }

  var essais = 0;
  var boucle = setInterval(function () {
    dedoublonner();
    if (++essais > 12) clearInterval(boucle);
  }, 600);
  document.addEventListener('DOMContentLoaded', dedoublonner);
})();


/* ============================================================
   IMAGE FAQ SUR MESURE (Lea) : autre photo pour shampooing,
   apres-shampooing et jelly milky
   ============================================================ */
(function () {
  var CIBLES = ['shampooing', 'apres-shampooing', 'jelly'];
  var handle = (window.location.pathname.split('/products/')[1] || '').split('?')[0];
  var concerne = CIBLES.some(function (c) { return handle.indexOf(c) !== -1; });
  if (!concerne) return;

  function autreImage() {
    var vignettes = document.querySelectorAll('.product__media-list img, .thumbnail-list img');
    var urls = [];
    vignettes.forEach(function (i) {
      var u = i.currentSrc || i.src;
      if (u && urls.indexOf(u) === -1) urls.push(u);
    });
    if (urls.length < 2) return null;
    return urls[1];
  }

  function poser() {
    var visuel = document.querySelector('.naqa-faq__visuel img');
    if (!visuel) return false;
    var url = autreImage();
    if (!url) return false;
    if (visuel.dataset.naqaFaq === '1') return true;
    visuel.dataset.naqaFaq = '1';
    visuel.src = url.replace(/([?&])width=\d+/, '$1width=900');
    visuel.removeAttribute('srcset');
    return true;
  }

  var n = 0;
  var boucle = setInterval(function () {
    if (poser() || ++n > 20) clearInterval(boucle);
  }, 600);
})();


/* ============================================================
   PAGE NOTRE HISTOIRE (Lea) : mise en page editoriale
   ============================================================ */
(function () {
  if (window.location.pathname.indexOf('/pages/notre-histoire') === -1) return;

  var CHIFFRES = [
    ['+ 5 000', 'clientes conquises'],
    ['100 %', 'formules clean'],
    ['France', 'formulation & fabrication'],
    ['halal', 'certifié sur nos cures']
  ];

  function poser() {
    var main = document.querySelector('main');
    if (!main || main.dataset.naqaHist === '1') return;
    var h1 = main.querySelector('h1');
    if (!h1) return;
    main.dataset.naqaHist = '1';
    main.classList.add('naqa-hist');

    var sous = document.createElement('p');
    sous.className = 'naqa-hist__sous';
    sous.textContent = 'née d’une communauté, pensée pour vos cheveux et votre peau.';
    h1.parentNode.insertBefore(sous, h1.nextSibling);

    var bande = document.createElement('div');
    bande.className = 'naqa-hist__chiffres';
    bande.innerHTML = CHIFFRES.map(function (c) {
      return '<div class="naqa-hist__chiffre"><strong>' + c[0] + '</strong><span>' + c[1] + '</span></div>';
    }).join('');
    sous.parentNode.insertBefore(bande, sous.nextSibling);

    main.querySelectorAll('h2').forEach(function (h2) {
      var bloc = document.createElement('section');
      bloc.className = 'naqa-hist__bloc';
      h2.parentNode.insertBefore(bloc, h2);
      bloc.appendChild(h2);
      var n = bloc.nextSibling;
      while (n && n.nodeName !== 'H2' && !(n.classList && n.classList.contains('naqa-hist__bloc'))) {
        var suiv = n.nextSibling;
        if (n.nodeName === 'DIV' && n.querySelector && n.querySelector('h2')) break;
        bloc.appendChild(n);
        n = suiv;
      }
    });

    var cta = document.createElement('div');
    cta.className = 'naqa-hist__cta';
    cta.innerHTML = '<a href="/collections/meilleures-ventes">découvrir nos best-sellers</a>';
    main.appendChild(cta);
  }

  var n = 0;
  var b = setInterval(function () { poser(); if (++n > 10) clearInterval(b); }, 500);
  document.addEventListener('DOMContentLoaded', poser);
})();


/* ============================================================
   GARDE-FOU CADEAUX (Lea) : aucun cadeau sous le palier
   ============================================================ */
(function () {
  var SEUIL_ECHANTILLON = 4000;   // 40 EUR
  var SEUIL_CADEAU = 20000;       // 200 EUR
  var IDS_ECHANTILLON = [54410566238554, 54410568171866];
  var IDS_CADEAU = [54410568302938, 54410568368474];
  var enCours = false;

  function totalEligible(cart) {
    var t = 0;
    (cart.items || []).forEach(function (it) {
      if (it.price === 0) return;
      t += it.line_price;
    });
    return t;
  }

  async function verifier() {
    if (enCours) return;
    enCours = true;
    try {
      var cart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
      var total = totalEligible(cart);
      var attrs = cart.attributes || {};
      var aRetirer = [];
      var majAttrs = {};

      if (total < SEUIL_ECHANTILLON) {
        if (attrs['Cadeau offert']) majAttrs['Cadeau offert'] = '';
        aRetirer = aRetirer.concat(IDS_ECHANTILLON);
      }
      if (total < SEUIL_CADEAU) {
        if (attrs['Cadeau']) majAttrs['Cadeau'] = '';
        aRetirer = aRetirer.concat(IDS_CADEAU);
      }

      var lignes = (cart.items || []).filter(function (it) {
        return aRetirer.indexOf(it.variant_id) !== -1 || aRetirer.indexOf(it.id) !== -1;
      });

      if (!lignes.length && !Object.keys(majAttrs).length) { enCours = false; return; }

      for (var i = 0; i < lignes.length; i++) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: lignes[i].key, quantity: 0 })
        });
      }
      if (Object.keys(majAttrs).length) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: majAttrs })
        });
      }
      if (typeof window.__naqaGiftRender === 'function') window.__naqaGiftRender();
      document.dispatchEvent(new CustomEvent('naqa:cadeaux-nettoyes'));
    } catch (e) {}
    enCours = false;
  }

  document.addEventListener('DOMContentLoaded', verifier);
  setInterval(verifier, 4000);
})();


/* ============================================================
   CADEAU DANS LA ZONE QUI DEFILE (Lea)
   Fix mobile : le bloc cadeau est deplace dans la zone
   scrollable du panier, pour que le bouton "valider ma
   commande" reste toujours atteignable (footer epingle).
   ============================================================ */
(function () {
  function replacer() {
    document.querySelectorAll('cart-drawer').forEach(function (drawer) {
      var body = drawer.querySelector('.cart-drawer__body');
      var extras = drawer.querySelector('.naqa-cart-extras');
      if (!body || !extras) return;
      // deja dans la zone qui defile ? on ne touche pas
      if (body.contains(extras)) return;
      // on le deplace tout en bas de la zone scrollable
      body.appendChild(extras);
    });
  }
  var b = setInterval(replacer, 500);
  document.addEventListener('DOMContentLoaded', replacer);
  document.addEventListener('naqa:cadeaux-nettoyes', replacer);
})();


/* ============================================================
   FORMULAIRE RETOUR EN STOCK GLOW (Lea)
   Affiche sur la fiche GLOW (si epuise) un champ e-mail
   branche sur la liste Klaviyo RC3Rqf. Retour prevu le 06/09.
   ============================================================ */
(function () {
  var HANDLE = 'gummies-collagene-verisol-peau-cheveux-ongles-halal';
  var COMPANY = 'WZxR5z';
  var LISTE = 'RC3Rqf';
  if (window.location.pathname.indexOf('/products/' + HANDLE) === -1) return;

  function estEpuise() {
    var btn = document.querySelector('product-form button[name="add"], .product-form__submit');
    if (!btn) return false;
    return btn.hasAttribute('disabled') || /\b(épuisé|sold out|indisponible)\b/i.test(btn.textContent);
  }

  function construire() {
    if (document.querySelector('.naqa-bis')) return true;
    if (!estEpuise()) return true;
    var ancre = document.querySelector('.product__info-container product-form') || document.querySelector('product-form') || document.querySelector('.naqa-trust');
    if (!ancre) return false;

    var bloc = document.createElement('div');
    bloc.className = 'naqa-bis';
    bloc.innerHTML =
      '<p class="naqa-bis__titre">de retour le <strong>4 octobre</strong> \u2661</p>' +
      '<p class="naqa-bis__texte">laisse ton e-mail, on te pr\u00e9vient d\u00e8s que la cure GLOW est de nouveau disponible.</p>' +
      '<form class="naqa-bis__form" novalidate>' +
      '<input type="email" required placeholder="ton e-mail" autocomplete="email" aria-label="ton e-mail">' +
      '<button type="submit">pr\u00e9viens-moi</button>' +
      '</form>' +
      '<p class="naqa-bis__ok" hidden>c\u2019est not\u00e9 \u2014 tu recevras un e-mail d\u00e8s son retour \u2661</p>' +
      '<p class="naqa-bis__err" hidden>oups, r\u00e9essaie dans un instant.</p>';
    ancre.parentNode.insertBefore(bloc, ancre.nextSibling);

    if (window.location.hash === '#previens-moi') {
      var viser = function () {
        var r = bloc.getBoundingClientRect();
        window.scrollTo({ top: r.top + window.scrollY - (window.innerHeight / 2) + (r.height / 2), behavior: 'instant' });
        var champ = bloc.querySelector('input');
        if (champ) champ.focus({ preventScroll: true });
      };
      setTimeout(viser, 700);
      setTimeout(viser, 2200);
      setTimeout(viser, 4000);
    }

    var form = bloc.querySelector('form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input');
      var email = (input.value || '').trim();
      if (!email || email.indexOf('@') === -1) { input.focus(); return; }
      var btn = form.querySelector('button');
      btn.disabled = true; btn.textContent = '\u2026';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              custom_source: 'Fiche produit GLOW \u2014 retour en stock'
            },
            relationships: { list: { data: { type: 'list', id: LISTE } } }
          }
        })
      }).then(function (r) {
        if (r.ok) {
          form.hidden = true;
          bloc.querySelector('.naqa-bis__ok').hidden = false;
          if (typeof fbq === 'function') fbq('track', 'Lead', { content_name: 'Liste attente GLOW Collagen' });
        } else { throw new Error(r.status); }
      }).catch(function () {
        bloc.querySelector('.naqa-bis__err').hidden = false;
        btn.disabled = false; btn.textContent = 'pr\u00e9viens-moi';
      });
    });
    return true;
  }

  var n = 0;
  var b = setInterval(function () { if (construire() || ++n > 20) clearInterval(b); }, 600);
  document.addEventListener('DOMContentLoaded', construire);
})();

;/* naqä — retouches de toutes les fiches produits (oct. 2026) :
   pas de Click & Collect, pas de badge « Retours 14 jours », pas de titre « choisis ta routine » quand il n'y a qu'une offre,
   « pourquoi on l'adore » sans répéter les puces du haut, et des photos sans texte, toutes différentes, dans les blocs du bas. */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  var handle = location.pathname.split('/products/')[1].split('/')[0];
  var GLOW = 'gummies-collagene-verisol-peau-cheveux-ongles-halal';

  var st = document.createElement('style');
  st.textContent = '.product__pickup-availabilities, pickup-availability, pickup-availability-preview { display: none !important; }'
    + ' quantity-breaks[data-naqa-solo] .quantity-breaks__title { display: none !important; }';
  document.head.appendChild(st);

  var AVANTAGES = {
    'masque-detox-purifiant-pores-eclat-secret-glow': [
      ["une peau purifiée", "Quatre argiles absorbent l'excès de sébum et les impuretés, sans agresser."],
      ["un teint plus net", "Arbre à thé et sauge sclarée aident à réduire visiblement les imperfections."],
      ["pour toutes les peaux", "Sèche, grasse, mixte ou sensible : 98 % d'origine naturelle, fabriqué en France."]
    ],
    'shampooing-hydratant-cheveux-boucles-good-curls': [
      ["un lavage tout en douceur", "Sans sulfates : des tensioactifs issus du sucre et de la noix de coco nettoient sans dessécher."],
      ["un cuir chevelu apaisé", "L'aloe vera bio apaise le cuir chevelu et nourrit la fibre."],
      ["des boucles plus élastiques", "Les graines de chia, riches en oméga-3 et en protéines, fortifient la boucle."]
    ],
    'apres-shampooing-demealant-cheveux-boucles-good-curls': [
      ["un démêlage facile", "La texture glisse dans la fibre : moins de nœuds, moins de casse au peigne."],
      ["des boucles dessinées", "Beurre de sapote, lin et aloe vera définissent chaque boucle dès le rinçage."],
      ["des longueurs légères", "Huiles bio et squalane nourrissent sans alourdir ni graisser les racines."]
    ],
    'soin-sans-rincage-double-texture-gelee-creme-boucles-jelly-milky': [
      ["une boucle sculptée en souplesse", "Elle gaine la fibre et dessine la boucle, sans effet carton."],
      ["des boucles nourries", "Jojoba, argan, aloe vera, hibiscus et bambou hydratent et renforcent chaque longueur."],
      ["un parfum monoï-coco", "Coco, fleur de tiaré et vanille : un sillage solaire qui dure toute la journée."]
    ],
    'coffret-routine-curly-complete-cheveux-boucles-dreamy-curls': [
      ["tout est réuni", "Lavage, soin, coiffage et nuit : chaque étape s'enchaîne, sans tester à l'aveugle."],
      ["des formules clean", "Sans sulfates agressifs, sans silicones ni parabènes, pour respecter vos boucles."],
      ["un cadeau prêt à offrir", "Présenté dans une boîte magnétique, sans emballage supplémentaire."]
    ],
    'parfum-cheveux-texture-huilee-vanille-aura-vanilla': [
      ["une formule sans alcool", "Elle parfume sans assécher, sans rigidifier ni étouffer la fibre."],
      ["une fibre renforcée", "Les protéines végétales de pois chiche, quinoa et lentille renforcent le cheveu."],
      ["un fini brillant", "Sur cheveux secs ou humides, elle gaine et apporte de la brillance en un geste."]
    ],
    'parfum-cheveux-huile-seche-florale-aura-blanche': [
      ["une formule sans alcool", "Elle parfume sans assécher, sans rigidifier ni étouffer la fibre."],
      ["une fibre renforcée", "Les protéines végétales de pois chiche, quinoa et lentille renforcent le cheveu."],
      ["un fini brillant", "Sur cheveux secs ou humides, elle gaine et apporte de la brillance en un geste."]
    ],
    'brume-corps-apres-douche-ultra-concentree-fleurs-blanches-bloomist': [
      ["un sillage qui tient", "Sur peau encore humide, ses notes se fixent pour un sillage longue tenue."],
      ["une caresse parfumée", "Une texture aérienne qui se dépose comme un souffle, jamais entêtante."],
      ["fabriquée en France", "Une parfumerie de qualité, qui se conserve 36 mois après ouverture."]
    ]
  };

  /* blocs du bas = photos SANS texte (la galerie du haut garde les visuels avec texte) */
  var PHOTOS = {
    'masque-detox-purifiant-pores-eclat-secret-glow': {
      hero: '41.png', vignette: '43.png', why: '44.png', faq: '19_a56c5052-d9b8-456e-9094-113f718b42bf.png'
    },
    'shampooing-hydratant-cheveux-boucles-good-curls': {
      hero: 'goodcurll.png', why: '1_6bd884c0-8efa-42b5-92f8-c204ee79775d.png', faq: 'shampoofemme.png'
    },
    'apres-shampooing-demealant-cheveux-boucles-good-curls': {
      hero: 'hf_20260508_090258_842794d2-9042-4daf-880d-a29154587633.png', why: 'goodcurll.png', faq: '2_1b9464a7-7a41-4854-b00f-a502ccda9378.png'
    },
    'soin-sans-rincage-double-texture-gelee-creme-boucles-jelly-milky': {
      hero: 'jellyserviette.png', why: '3_07ed8270-2ab9-42ff-a222-e7504f6201bb.png', faq: 'shampoofemme.png'
    },
    'brosse-demealante-definition-cheveux-boucles-sculptor-brush': {
      hero: 'brossesalledeb.jpg', faq: '4_40495869-05f6-4de0-8aee-acb2cb161c42.png'
    },
    'coffret-routine-curly-complete-cheveux-boucles-dreamy-curls': {
      hero: 'jellyserviette.png', vignette: 'brossesalledeb.jpg', why: 'goodcurll.png', faq: 'shampoofemme.png'
    },
    'parfum-cheveux-texture-huilee-vanille-aura-vanilla': {
      hero: '36_dbe6600e-4fe5-4fda-ab72-1f3b0fcfda99.png', vignette: '37_3d98ee43-021d-4912-a573-0a533c1b19a4.png',
      why: '39_0276e299-b985-470c-879d-4e3c2a6c53ce.png', faq: '13_adfac8cf-d783-4bfd-a546-f57ad150899e.png'
    },
    'parfum-cheveux-huile-seche-florale-aura-blanche': {
      hero: '43_c7b8fd74-8262-4e27-b42c-edb2775f23a0.png', vignette: '41_3e9d7ac0-d355-41b7-8626-391f8f42db81.png',
      why: '42_de0d7a2e-994a-423d-beb2-d0744732a6dd.png', faq: '12_ea3b321b-c692-4ab3-9232-ccf532e2fa46.png'
    },
    'brume-corps-apres-douche-ultra-concentree-fleurs-blanches-bloomist': {
      hero: '14_d8af77fc-87c6-4da5-8b95-29d173e7cb03.png', vignette: '11_70b6e1bc-4b49-4f1f-901b-ccc8da8c55eb.png',
      why: '12_518c3946-98e7-4b17-96a5-f05bd2e0d7a9.png', faq: '14_84e5f9c4-b7e1-4f80-a7ee-82dcfb399757.png'
    }
  };
  var BLOCS = { hero: '.naqa-app__hero img', vignette: '.naqa-app__vignette img', why: '.naqa-why__visuel img', faq: '.naqa-faq__visuel img' };

  function cle(u) { return (u || '').split('?')[0].split('/').pop(); }

  function retoucher() {
    document.querySelectorAll('.naqa-trust__item').forEach(function (it) {
      if (/Retours 14 jours/i.test(it.textContent)) it.remove();
    });

    document.querySelectorAll('quantity-breaks').forEach(function (qb) {
      if (qb.querySelectorAll('label.quantity-break').length === 1) qb.setAttribute('data-naqa-solo', '');
      else qb.removeAttribute('data-naqa-solo');
    });

    if (handle === GLOW) return;

    var col = document.querySelectorAll('.naqa-why__col')[1];
    if (col && !col.dataset.naqaAv && AVANTAGES[handle]) {
      col.dataset.naqaAv = '1';
      col.innerHTML = '<p class="naqa-why__sous">avantages</p>' + AVANTAGES[handle].map(function (a) {
        return '<p class="naqa-why__nom">' + a[0] + '</p><p class="naqa-why__desc">' + a[1] + '</p>';
      }).join('');
    }

    if (PHOTOS[handle]) {
      Object.keys(PHOTOS[handle]).forEach(function (bloc) {
        var photo = PHOTOS[handle][bloc];
        document.querySelectorAll(BLOCS[bloc]).forEach(function (img) {
          /* on compare à la photo réellement affichée : le thème peut remettre l'ancienne après coup */
          if (cle(img.getAttribute('src')) === photo) return;
          img.dataset.naqaPhoto = photo;
          img.removeAttribute('srcset');
          img.src = '/cdn/shop/files/' + photo + '?width=1600';
        });
      });
      return;
    }

    var galerie = [], vues = {};
    document.querySelectorAll('.product__media-item img').forEach(function (im) {
      var s = im.currentSrc || im.src, k = cle(s);
      if (s && !vues[k]) { vues[k] = 1; galerie.push({ k: k, src: s }); }
    });
    if (galerie.length < 2) return;
    var prises = {};
    ['.naqa-app__hero img', '.naqa-app__vignette img', '.naqa-why__visuel img', '.naqa-faq__visuel img'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (img) {
        var k = img.dataset.naqaPhoto || cle(img.currentSrc || img.src);
        if (!prises[k]) { prises[k] = 1; return; }
        for (var i = 1; i <= galerie.length; i++) {
          var g = galerie[i % galerie.length];
          if (prises[g.k]) continue;
          prises[g.k] = 1;
          img.dataset.naqaPhoto = g.k;
          img.removeAttribute('srcset');
          img.src = g.src;
          return;
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', retoucher);
  else retoucher();
  setInterval(retoucher, 500);
})();

/* Dreamy Curls épuisé : formulaire « préviens-moi » (liste Klaviyo « Retour en stock — Dreamy Curls »), même bloc que la liste d'attente GLOW */
(function () {
  var HANDLE = 'coffret-routine-curly-complete-cheveux-boucles-dreamy-curls', COMPANY = 'WZxR5z', LISTE = 'WxB2DW';
  if (location.pathname.indexOf('/products/' + HANDLE) === -1) return;
  function estEpuise() {
    var btn = document.querySelector('product-form button[name="add"], .product-form__submit');
    return btn ? btn.hasAttribute('disabled') || /\b(épuisé|sold out|indisponible)\b/i.test(btn.textContent) : false;
  }
  function construire() {
    if (document.querySelector('.naqa-bis') || !estEpuise()) return true;
    document.querySelectorAll('quantity-breaks').forEach(function (qb) { qb.style.display = 'none'; });
    var ancre = document.querySelector('.product__info-container product-form') || document.querySelector('product-form') || document.querySelector('.naqa-trust');
    if (!ancre) return false;
    var bloc = document.createElement('div');
    bloc.className = 'naqa-bis';
    bloc.innerHTML = '<p class="naqa-bis__titre">bientôt de retour \u2661</p>'
      + '<p class="naqa-bis__texte">laisse ton e-mail, on te prévient dès que le coffret Dreamy Curls est de nouveau disponible.</p>'
      + '<form class="naqa-bis__form" novalidate><input type="email" required placeholder="ton e-mail" autocomplete="email" aria-label="ton e-mail"><button type="submit">préviens-moi</button></form>'
      + '<p class="naqa-bis__ok" hidden>c\u2019est noté \u2014 tu recevras un e-mail dès son retour \u2661</p>'
      + '<p class="naqa-bis__err" hidden>oups, réessaie dans un instant.</p>';
    ancre.parentNode.insertBefore(bloc, ancre.nextSibling);
    var form = bloc.querySelector('form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input'), email = (input.value || '').trim();
      if (!email || email.indexOf('@') === -1) { input.focus(); return; }
      var btn = form.querySelector('button');
      btn.disabled = true; btn.textContent = '\u2026';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              custom_source: 'Fiche produit Dreamy Curls \u2014 retour en stock'
            },
            relationships: { list: { data: { type: 'list', id: LISTE } } }
          }
        })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        form.hidden = true;
        bloc.querySelector('.naqa-bis__ok').hidden = false;
        if (typeof fbq === 'function') fbq('track', 'Lead', { content_name: 'Liste attente Dreamy Curls' });
      }).catch(function () {
        bloc.querySelector('.naqa-bis__err').hidden = false;
        btn.disabled = false; btn.textContent = 'préviens-moi';
      });
    });
    return true;
  }
  var n = 0;
  var b = setInterval(function () { if (construire() || ++n > 20) clearInterval(b); }, 600);
  document.addEventListener('DOMContentLoaded', construire);
})();

/* GLOW Collagen : case « Ajouter le masque Secret Glow » sous les cures (l'option du sélecteur ne s'affiche pas en style vertical) */
(function () {
  if (location.pathname.indexOf('/products/gummies-collagene-verisol-peau-cheveux-ongles-halal') === -1) return;
  var SECRET_GLOW = 47718757826906;
  var st = document.createElement('style');
  st.textContent = '.naqa-sg { display: flex; align-items: center; gap: 12px; margin: 12px 0 4px; padding: 10px 14px; border: 2px solid rgb(94, 1, 1); border-radius: 10px; background: #fff; cursor: pointer; font-size: 1.35rem; line-height: 1.3; color: rgb(26, 26, 26); }'
    + ' .naqa-sg:has(input:checked) { background: rgb(255, 193, 216); }'
    + ' .naqa-sg input { width: 18px; height: 18px; margin: 0; accent-color: rgb(94, 1, 1); flex-shrink: 0; }'
    + ' .naqa-sg img { width: 46px; height: 46px; object-fit: cover; border-radius: 8px; flex-shrink: 0; }'
    + ' .naqa-sg__txt { flex: 1; } .naqa-sg__txt strong { font-weight: 600; } .naqa-sg__prix { font-weight: 600; white-space: nowrap; }';
  document.head.appendChild(st);

  function construire() {
    if (document.querySelector('.naqa-sg--masque')) return true;
    var qb = document.querySelector('quantity-breaks');
    if (!qb) return false;
    var bloc = document.createElement('label');
    bloc.className = 'naqa-sg naqa-sg--masque';
    bloc.innerHTML = '<input type="checkbox"><img src="/cdn/shop/files/43.png?width=160" alt="">'
      + '<span class="naqa-sg__txt"><strong>Ajouter le masque Secret Glow</strong><br>détox & éclat, pour compléter la cure</span>'
      + '<span class="naqa-sg__prix">+ 36,90 €</span>';
    var apres = document.querySelector('.naqa-abo') || qb;
    apres.parentNode.insertBefore(bloc, apres.nextSibling);
    return true;
  }

  /* si la case est cochée : on ajoute d'abord le masque, puis on laisse le formulaire du thème ajouter la cure et ouvrir le panier */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action$="/cart/add"]') || form.closest('[data-is-cart-upsell]')) return;
    var cb = document.querySelector('.naqa-sg--masque input');
    if (!cb || !cb.checked) return;
    if (form.dataset.naqaSg === '1') { delete form.dataset.naqaSg; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: SECRET_GLOW, quantity: 1 }] })
    }).catch(function () {}).then(function () {
      form.dataset.naqaSg = '1';
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }, true);

  var n = 0;
  var b = setInterval(function () { if (construire() || ++n > 20) clearInterval(b); }, 600);
  document.addEventListener('DOMContentLoaded', construire);
})();

/* « GLOW Collagen » avec ses majuscules aussi dans le panier (le thème passe les titres en minuscules) */
(function () {
  function majuscules() {
    document.querySelectorAll('cart-drawer, cart-items, cart-notification, .cart-drawer, .cart__items').forEach(function (zone) {
      var w = document.createTreeWalker(zone, NodeFilter.SHOW_TEXT), nodes = [];
      while (w.nextNode()) nodes.push(w.currentNode);
      nodes.forEach(function (n) {
        if (!/glow collagen/i.test(n.nodeValue) || (n.parentNode.closest && n.parentNode.closest('[data-naqa-gc]'))) return;
        var s = document.createElement('span');
        s.innerHTML = n.nodeValue.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/glow collagen/ig, '<span data-naqa-gc style="text-transform:none !important">GLOW Collagen</span>');
        n.parentNode.replaceChild(s, n);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', majuscules);
  setInterval(majuscules, 700);
})();

/* Vrais duos (app Shopify Bundles) : l'offre « + populaire » d'Aura et de Bloomist ajoute le produit duo au lieu de 2× le même produit */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  var handle = location.pathname.split('/products/')[1].split('/')[0];
  var DUO_AURA = { variante: 55010832777562, photo: '33_955d1826-75dc-458a-abc6-2c5d42dbbd29.png' };
  /* le thème calcule l'offre 2 comme « 2 brumes » (56,81 €) : on affiche le vrai prix du duo (Bloomist + Bloomy Bag, -5 %) */
  var DUO_BLOOMIST = {
    variante: 55010838872410, photo: '49_d5ff5ead-74b2-4376-80bb-b930d2bc61eb.png', libelle: '1 brume The Bloomist + 1 Bloomy Bag',
    prix: { '56,81': '66,31', '59,80': '69,80' }
  };
  var DUOS = {
    'parfum-cheveux-texture-huilee-vanille-aura-vanilla': { variante: DUO_AURA.variante, photo: DUO_AURA.photo, libelle: '1 Aura Vanilla + 1 Aura Blanche' },
    'parfum-cheveux-huile-seche-florale-aura-blanche': { variante: DUO_AURA.variante, photo: DUO_AURA.photo, libelle: '1 Aura Blanche + 1 Aura Vanilla' },
    'brume-corps-apres-douche-ultra-concentree-fleurs-blanches-bloomist': DUO_BLOOMIST
  };
  var duo = DUOS[handle];
  if (!duo) return;

  function afficher() {
    var carte = document.querySelector('quantity-breaks label.quantity-break[data-quantity="2"]');
    if (!carte) return;
    var texte = carte.querySelector('.quantity-break__label-text');
    var html = '<strong>' + duo.libelle + '</strong>';
    if (texte && texte.getAttribute('data-text') !== html) { texte.setAttribute('data-text', html); texte.innerHTML = html; }
    var img = carte.querySelector('.quantity-break__image img');
    if (img && img.getAttribute('src').indexOf(duo.photo) === -1) { img.removeAttribute('srcset'); img.src = '/cdn/shop/files/' + duo.photo + '?width=400'; }
    if (duo.prix) corrigerPrix(carte);
  }

  function corrigerPrix(carte) {
    var zones = [carte].concat([].slice.call(document.querySelectorAll('.main-atc__label, .price-item, .sticky-atc__label__text')));
    zones.forEach(function (zone) {
      var w = document.createTreeWalker(zone, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        var v = n.nodeValue;
        Object.keys(duo.prix).forEach(function (faux) { v = v.split(faux).join(duo.prix[faux]); });
        if (v !== n.nodeValue) n.nodeValue = v;
      }
    });
  }

  /* au clic sur « acheter » avec l'offre 2 : on envoie 1 duo au lieu de 2× le produit, puis on remet le formulaire comme avant */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action$="/cart/add"]') || form.closest('[data-is-cart-upsell]')) return;
    var choix = document.querySelector('quantity-breaks input[name="quantity"]:checked');
    var id = form.querySelector('input[name="id"]');
    if (!choix || choix.value !== '2' || !id) return;
    var ancienId = id.value;
    id.value = duo.variante;
    choix.value = '1';
    setTimeout(function () { id.value = ancienId; choix.value = '2'; }, 0);
  }, true);

  document.addEventListener('DOMContentLoaded', afficher);
  setInterval(afficher, 500);
  if (duo.prix) {
    var prevu = false;
    new MutationObserver(function () {
      if (prevu) return;
      prevu = true;
      requestAnimationFrame(function () { prevu = false; afficher(); });
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
})();

/* GLOW Collagen : abonnement Shopify Subscriptions (1 pot chaque mois, -10 %, sans engagement) — uniquement avec la cure 1 mois */
(function () {
  if (location.pathname.indexOf('/products/gummies-collagene-verisol-peau-cheveux-ongles-halal') === -1) return;
  var FORFAIT = '692268695898';
  var PRIX = '59,90 €', PRIX_ABO = '53,91 € / mois';

  function cocheAbo() { var cb = document.querySelector('.naqa-abo input'); return cb && cb.checked; }

  function majPrix() {
    var abonne = cocheAbo();
    document.querySelectorAll('.main-atc__label, .sticky-atc__label__text').forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        var v = abonne ? n.nodeValue.split(PRIX).join(PRIX_ABO) : n.nodeValue.split(PRIX_ABO).join(PRIX);
        if (v !== n.nodeValue) n.nodeValue = v;
      }
    });
  }

  function construire() {
    if (document.querySelector('.naqa-abo')) return true;
    var qb = document.querySelector('quantity-breaks');
    if (!qb) return false;
    var bloc = document.createElement('label');
    bloc.className = 'naqa-sg naqa-abo';
    bloc.innerHTML = '<input type="checkbox"><img src="/cdn/shop/files/glow-collagen-cure-photo.png?width=160" alt="">'
      + '<span class="naqa-sg__txt"><strong>S\u2019abonner et économiser 10 %</strong><br>1 pot livré chaque mois, sans engagement</span>'
      + '<span class="naqa-sg__prix">53,91 €<br><small style="font-weight:400">/ mois</small></span>';
    qb.parentNode.insertBefore(bloc, qb.nextSibling);
    bloc.querySelector('input').addEventListener('change', function () {
      if (this.checked) {
        var un = document.querySelector('quantity-breaks input[name="quantity"][value="1"]');
        if (un && !un.checked) document.querySelector('quantity-breaks label[for="' + un.id + '"]').click();
      }
      setTimeout(majPrix, 50);
    });
    /* une autre cure que « 1 mois » = achat unique */
    document.querySelectorAll('quantity-breaks input[name="quantity"]').forEach(function (r) {
      r.addEventListener('change', function () {
        var cb = document.querySelector('.naqa-abo input');
        if (cb && r.checked && r.value !== '1') cb.checked = false;
        setTimeout(majPrix, 50);
      });
    });
    return true;
  }

  /* au clic sur « acheter » : on joint le forfait d'abonnement au formulaire du thème (ou on le retire) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action$="/cart/add"]') || form.closest('[data-is-cart-upsell]')) return;
    var champ = form.querySelector('input[name="selling_plan"]');
    if (cocheAbo()) {
      if (!champ) { champ = document.createElement('input'); champ.type = 'hidden'; champ.name = 'selling_plan'; form.appendChild(champ); }
      champ.value = FORFAIT;
    } else if (champ) {
      champ.remove();
    }
  }, true);

  var n = 0;
  var b = setInterval(function () { if (construire() || ++n > 20) clearInterval(b); }, 600);
  document.addEventListener('DOMContentLoaded', construire);
  setInterval(majPrix, 500);
})();
